import React, { useState } from "react";
import {
    commonService,
    AppConfigData,
} from "../_services/common.service";
import { useHistory } from "react-router-dom";
import _Skeleton, { _SkeletonType } from "./_Skeleton";
import _NoDataFound from "./_NoDataFound";
import { Doughnut } from "react-chartjs-2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Spinner from "react-bootstrap/Spinner";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import { viewFilePopupService } from "../_services/viewFilePopup.service";
import $ from 'jquery';
import Select from "react-select";
import { alertService, AlertType } from "../_services/alert.service";
import { Button, Table } from "react-bootstrap";

function Exam() {
    const history = useHistory();
    let data = commonService.getLoginUserData();
    const [Exam, setExam] = useState({ IsData: false, data: [] });
    const [WeeklyResult, setWeeklyResult] = useState({ IsData: false, data: [] });
    const [TermsResult, setTermsResult] = useState({ IsData: false, data: [] });
    const [SemResult, setSemResult] = useState({ IsData: false, data: [] });
    const [CbseResult, setCbseResult] = useState({ IsData: false, data: [] });
    const [ResultSheetData, setResultSheetData] = useState({ IsData: false, data: [] });
    const [txtEndDate, setTxtEndDate] = useState(null);
    const [txtStartDate, setTxtStartDate] = useState(null);
    const [txtSearch, setTxtSearch] = useState("");
    const [IsListDateLodding, setIsListDateLodding] = useState(false);

    function BindExamList() {
        setExam({ IsData: false, data: [] });
        setIsListDateLodding(true);
        const reqExam = {
            method: "POST",
            headers: commonService.getHeaders(),
            body: JSON.stringify({
                saveType: "Send",
                searchText: txtSearch,
                fromDate: txtStartDate,
                toDate: txtEndDate,
                requestFrom: "Web",
                noOfData: null,
            }),
        };
        fetch(AppConfigData.APIBasePath + "v1/exam/getlistbymember", reqExam)
            .then((response) => response.json())
            .then(function (json) {
                setIsListDateLodding(false);
                if (json.status_code === 1) {
                    setExam({ IsData: true, data: json.data });
                } else if (json.status_code === 0) {
                    setExam({ IsData: true, data: [] });
                } else if (json.status_code === 2) {
                    localStorage.clear();
                    history.push("/");
                }
            });
    }

    function ViewExamDetailsPage(item) {
        history.push({
            pathname: "/examsyllabus",
            state: item,
        });
    }

    function BindWeeklyResult() {
        setWeeklyResult({ IsData: false, data: [] });
        const reqWeeklyResult = {
            method: "POST",
            headers: commonService.getHeaders(),
            body: JSON.stringify({
                examType: "Weekly",
            }),
        };
        fetch(
            AppConfigData.APIBasePath + "v1/exam/getstudentweeklyresultlist",
            reqWeeklyResult
        )
            .then((response) => response.json())
            .then(function (json) {
                if (json.status_code === 1) {
                    setWeeklyResult({ IsData: true, data: json.data });
                } else if (json.status_code === 0) {
                    setWeeklyResult({ IsData: true, data: [] });
                } else if (json.status_code === 2) {
                    localStorage.clear();
                    history.push("/");
                }
            });
    }

    function BindTermsResult() {
        setTermsResult({ IsData: false, data: [] });

        const reqTermResult = {
            method: "POST",
            headers: commonService.getHeaders(),
            body: JSON.stringify({
                examType: "TERM",
            }),
        };
        fetch(
            AppConfigData.APIBasePath + "v1/exam/getstudent_term_sem_cbse_resultlist",
            reqTermResult
        )
            .then((response) => response.json())
            .then(function (json) {
                if (json.status_code === 1) {
                    setTermsResult({ IsData: true, data: json.data });
                } else if (json.status_code === 0) {
                    setTermsResult({ IsData: true, data: [] });
                } else if (json.status_code === 2) {
                    localStorage.clear();
                    history.push("/");
                }
            });
    }

    function BindSemResult() {
        setSemResult({ IsData: false, data: [] });

        const reqSemResult = {
            method: "POST",
            headers: commonService.getHeaders(),
            body: JSON.stringify({
                examType: "SEMESTER",
            }),
        };
        fetch(
            AppConfigData.APIBasePath + "v1/exam/getstudent_term_sem_cbse_resultlist",
            reqSemResult
        )
            .then((response) => response.json())
            .then(function (json) {
                if (json.status_code === 1) {
                    setSemResult({ IsData: true, data: json.data });
                } else if (json.status_code === 0) {
                    setSemResult({ IsData: true, data: [] });
                } else if (json.status_code === 2) {
                    localStorage.clear();
                    history.push("/");
                }
            });
    }

    function BindCbseResult() {
        setCbseResult({ IsData: false, data: [] });

        const reqCbseResult = {
            method: "POST",
            headers: commonService.getHeaders(),
            body: JSON.stringify({
                examType: "CBSE",
            }),
        };
        fetch(
            AppConfigData.APIBasePath + "v1/exam/getstudent_term_sem_cbse_resultlist",
            reqCbseResult
        )
            .then((response) => response.json())
            .then(function (json) {
                if (json.status_code === 1) {
                    setCbseResult({ IsData: true, data: json.data });
                } else if (json.status_code === 0) {
                    setCbseResult({ IsData: true, data: [] });
                } else if (json.status_code === 2) {
                    localStorage.clear();
                    history.push("/");
                }
            });
    }

    function ChangeExamTypeDisplayName(Type) {
        if (Type.toLowerCase() === "cbsc exam") {
            Type = "CBSE/ICSE Exam";
        }

        return Type;
    }

    function GetResultSheetPath(item) {
        $.ajax({
            url: item,
            type: "POST",
            success: function (data) {
                window.open(AppConfigData.ERPBasePath + data, "_blank");
            }
        });
    }

    function BindResultSheet() {
        setResultSheetData({ IsData: false, data: [] });

        const reqResultSheet = {
            method: "POST",
            headers: commonService.getHeaders()
        };

        fetch(
            AppConfigData.APIBasePath + "v1/exam/GetClassTeacherWiseExams",
            reqResultSheet
        )
            .then((response) => response.json())
            .then(function (json) {
                if (json.status_code === 1) {
                    setResultSheetData({ IsData: true, data: json.data });
                } else if (json.status_code === 0) {
                    setResultSheetData({ IsData: true, data: [] });
                } else if (json.status_code === 2) {
                    localStorage.clear();
                    history.push("/");
                }
            });
    }

    React.useEffect(() => {
        if (commonService.getLoginRoleData("Exam", "IsView")) {
            BindExamList();
            BindWeeklyResult();
            BindTermsResult();
            BindSemResult();
            BindCbseResult();
            BindResultSheet();
        }
        else {
            history.push("/access");
        }
    }, []);

    const [StandardDivisionID, setStandardDivisionID] = useState("");
    const [TeacherStdDiv, setTeacherStdDiv] = useState([]);
    const [ExamMaster, setExamMaster] = useState([]);
    const [ExamMasterID, setExamMasterID] = useState("");
    const [StandardSubject, setStandardSubject] = useState([]);
    const [StandardSubjectID, setStandardSubjectID] = useState("");
    const [StandardDivisionTermExam, setStandardDivisionTermExam] = useState(null);
    const [StandardDivisionSemesterExam, setStandardDivisionSemesterExam] = useState(null);
    const [StandardDivisionCBSEExam, setStandardDivisionCBSEExam] = useState(null);

    const [StandardDivisionTermFinal, setStandardDivisionTermFinal] = useState(null);
    const [StandardDivisionSemesterFinal, setStandardDivisionSemesterFinal] = useState(null);
    const [StandardDivisionCBSEFinal, setStandardDivisionCBSEFinal] = useState("");

    const [TermExamName, setTermExamName] = useState([]);
    const [SemesterExamName, setSemesterExamName] = useState([]);
    const [CBSEExamName, setCBSEExamName] = useState([]);

    const [TermFinalExamName, setTermFinalExamName] = useState([]);
    const [SemesterFinalExamName, setSemesterFinalExamName] = useState([]);
    const [CBSEFinalExamName, setCBSEFinalExamName] = useState([]);

    const [TermExamID, setTermExamID] = useState(null);
    const [SemesterExamID, setSemesterExamID] = useState(null);
    const [CBSEExamID, setCBSEExamID] = useState(null);
    const [CBSEFinalExamID, setCBSEFinalExamID] = useState(null);

    const [TermStudentList, setTermStudentList] = useState({ IsData: true, data: [] });
    const [TermFinalStudentList, setTermFinalStudentList] = useState({ IsData: true, data: [] });

    const [SemesterStudentList, setSemesterStudentList] = useState({ IsData: true, data: [] });
    const [SemesterFinalStudentList, setSemesterFinalStudentList] = useState({ IsData: true, data: [] });

    const [CBSEStudentList, setCBSEStudentList] = useState({ IsData: true, data: [] });
    const [CBSEFinalStudentList, setCBSEFinalStudentList] = useState({ IsData: true, data: [] });

    const [ResultProcessRemarks, setResultProcessRemarks] = useState([]);
    const [txtTermStartDate, setTxtTermStartDate] = useState(null);
    const [txtTermEndDate, setTxtTermEndDate] = useState(null);

    function GetStandardDivisionData() {
        setTeacherStdDiv([]);
        const reqSTDDIV = {
            method: "POST",
            headers: commonService.getHeaders(),
        };
        fetch(
            AppConfigData.APIBasePath + "v1/home/get_teacher_standarddivision",
            reqSTDDIV
        )
            .then((response) => response.json())
            .then(function (json) {
                if (json.status_code === 1) {
                    let Options = [];
                    for (let i = 0; i < json.data.length; i++) {
                        if (json.data[i].IsClassTeacher) {
                            Options.push({
                                value: json.data[i].IDs.toLocaleUpperCase(),
                                label: json.data[i].Text,
                            });
                        }
                    }
                    setTeacherStdDiv(Options);
                } else if (json.status_code === 0) {
                } else if (json.status_code === 2) {
                    localStorage.clear();
                    history.push("/");
                }
            });
    }

    function GetStandardWiseExamData() {
        setExamMaster([]);
        setExamMasterID("");
        const reqSTDDIV = {
            method: "POST",
            headers: commonService.getHeaders(),
            body: JSON.stringify({
                StandardID: StandardDivisionID.split("|")[0],
            }),
        };
        fetch(
            AppConfigData.APIBasePath + "v1/exam/GetStandardWiseScheduledCBSEExam",
            reqSTDDIV
        )
            .then((response) => response.json())
            .then(function (json) {
                if (json.status_code === 1) {
                    let Options = [];
                    for (let i = 0; i < json.data.length; i++) {
                        Options.push({
                            value: json.data[i].ExamMasterID.toLocaleUpperCase(),
                            label: json.data[i].ExamName,
                        });
                    }
                    setExamMaster(Options);
                } else if (json.status_code === 0) {
                } else if (json.status_code === 2) {
                    localStorage.clear();
                    history.push("/");
                }
            });
    }

    function GetStandardWiseSubjectData() {
        setStandardSubject([]);
        setStandardSubjectID("");

        const reqSTDDIV = {
            method: "POST",
            headers: commonService.getHeaders(),
            body: JSON.stringify({
                StandardID: StandardDivisionID.split("|")[0],
            }),
        };
        fetch(
            AppConfigData.APIBasePath + "v1/exam/GetStandardWiseCBSEScholaticSubject",
            reqSTDDIV
        )
            .then((response) => response.json())
            .then(function (json) {
                if (json.status_code === 1) {
                    let Options = [];
                    for (let i = 0; i < json.data.length; i++) {
                        Options.push({
                            value: json.data[i].ScholaticAreaSubjectID.toLocaleUpperCase(),
                            label: json.data[i].Name,
                        });
                    }
                    setStandardSubject(Options);
                } else if (json.status_code === 0) {
                } else if (json.status_code === 2) {
                    localStorage.clear();
                    history.push("/");
                }
            });
    }

    function StandardDivisionChange(e) {
        setStandardDivisionStudentData({ IsData: true, data: [] });
        setGradeData([])
        setStandardDivisionID(e.value);
    }

    function StandardSubjectChange(e) {
        setStandardDivisionStudentData({ IsData: true, data: [] });
        setGradeData([])
        setStandardSubjectID(e.value);
    }

    function ExamMasterChange(e) {
        setStandardDivisionStudentData({ IsData: true, data: [] });
        setGradeData([])
        setExamMasterID(e.value);
    }

    function GetTermExamByStandardDivisionID(e) {
        setStandardDivisionTermExam(e);
        setTermExamName([]);
        setTermExamID(null);

        const reqSTDDIV = {
            method: "POST",
            headers: commonService.getHeaders(),
            body: JSON.stringify({
                StandardID: e.value.split("|")[0],
            }),
        };
        fetch(
            AppConfigData.APIBasePath + "v1/exam/StandardWiseTermExam",
            reqSTDDIV
        )
            .then((response) => response.json())
            .then(function (json) {
                if (json.status_code === 1) {
                    let Options = [];
                    for (let i = 0; i < json.data.examList.length; i++) {
                        Options.push({
                            value: json.data.examList[i].ExamMasterID,
                            label: json.data.examList[i].ExamName,
                        });
                    }
                    setTermExamName(Options);
                } else if (json.status_code === 0) {
                } else if (json.status_code === 2) {
                    localStorage.clear();
                    history.push("/");
                }
            });
    }

    function GetSemesterExamByStandardDivisionID(e) {
        setStandardDivisionSemesterExam(e);
        const reqSTDDIV = {
            method: "POST",
            headers: commonService.getHeaders(),
            body: JSON.stringify({
                StandardID: e.value.split("|")[0],
            }),
        };
        fetch(
            AppConfigData.APIBasePath + "v1/exam/StandardWiseSemesterExam",
            reqSTDDIV
        )
            .then((response) => response.json())
            .then(function (json) {
                if (json.status_code === 1) {
                    let Options = [];
                    for (let i = 0; i < json.data.examList.length; i++) {
                        Options.push({
                            value: json.data.examList[i].ExamMasterID,
                            label: json.data.examList[i].ExamName,
                        });
                    }
                    setSemesterExamName(Options);
                } else if (json.status_code === 0) {
                } else if (json.status_code === 2) {
                    localStorage.clear();
                    history.push("/");
                }
            });
    }

    function GetCBSEExamByStandardDivisionID(e) {
        setStandardDivisionCBSEExam(e);
        const reqSTDDIV = {
            method: "POST",
            headers: commonService.getHeaders(),
            body: JSON.stringify({
                StandardID: e.value.split("|")[0],
            }),
        };
        fetch(
            AppConfigData.APIBasePath + "v1/exam/StandardWiseCBSEExam",
            reqSTDDIV
        )
            .then((response) => response.json())
            .then(function (json) {
                if (json.status_code === 1) {
                    let Options = [];
                    for (let i = 0; i < json.data.examList.length; i++) {
                        Options.push({
                            value: json.data.examList[i].ExamMasterID,
                            label: json.data.examList[i].ExamName,
                        });
                    }
                    setCBSEExamName(Options);
                } else if (json.status_code === 0) {
                } else if (json.status_code === 2) {
                    localStorage.clear();
                    history.push("/");
                }
            });
    }

    function GetTermFinalExamByStandardDivisionID(e) {
        setStandardDivisionTermFinal(e);
        const reqSTDDIV = {
            method: "POST",
            headers: commonService.getHeaders(),
            body: JSON.stringify({
                StandardID: e.value.split("|")[0],
            }),
        };
        fetch(
            AppConfigData.APIBasePath + "v1/exam/StandardWiseTermFinalExam",
            reqSTDDIV
        )
            .then((response) => response.json())
            .then(function (json) {
                if (json.status_code === 1) {
                    let Options = [];
                    for (let i = 0; i < json.data.examList.length; i++) {
                        Options.push({
                            value: json.data.examList[i].ExamMasterID,
                            label: json.data.examList[i].ExamName,
                        });
                    }
                    setTermFinalExamName(Options);
                } else if (json.status_code === 0) {
                } else if (json.status_code === 2) {
                    localStorage.clear();
                    history.push("/");
                }
            });
    }

    function GetSemesterFinalExamByStandardDivisionID(e) {
        setStandardDivisionSemesterFinal(e);
        const reqSTDDIV = {
            method: "POST",
            headers: commonService.getHeaders(),
            body: JSON.stringify({
                StandardID: e.value.split("|")[0],
            }),
        };
        fetch(
            AppConfigData.APIBasePath + "v1/exam/StandardWiseSemesterExam",
            reqSTDDIV
        )
            .then((response) => response.json())
            .then(function (json) {
                if (json.status_code === 1) {
                    let Options = [];
                    for (let i = 0; i < json.data.examList.length; i++) {
                        Options.push({
                            value: json.data.examList[i].ExamMasterID,
                            label: json.data.examList[i].ExamName,
                        });
                    }
                    setSemesterFinalExamName(Options);
                } else if (json.status_code === 0) {
                } else if (json.status_code === 2) {
                    localStorage.clear();
                    history.push("/");
                }
            });
    }

    function GetCBSEFinalExamByStandardDivisionID(e) {
        setStandardDivisionCBSEFinal(e);
        const reqSTDDIV = {
            method: "POST",
            headers: commonService.getHeaders(),
            body: JSON.stringify({
                StandardID: e.value.split("|")[0],
            }),
        };
        fetch(
            AppConfigData.APIBasePath + "v1/exam/StandardWiseCBSEFinalExam",
            reqSTDDIV
        )
            .then((response) => response.json())
            .then(function (json) {
                if (json.status_code === 1) {
                    let Options = [];
                    for (let i = 0; i < json.data.examList.length; i++) {
                        Options.push({
                            value: json.data.examList[i].ExamMasterID,
                            label: json.data.examList[i].ExamName,
                        });
                    }
                    setCBSEFinalExamName(Options);
                } else if (json.status_code === 0) {
                } else if (json.status_code === 2) {
                    localStorage.clear();
                    history.push("/");
                }
            });
    }

    function TermExamChange(e) {
        setTermExamID(e);
        setTermStudentList({ IsData: true, data: [] });
    }

    function SemesterExamChange(e) {
        setSemesterExamID(e);
        setSemesterStudentList({ IsData: true, data: [] });
    }

    function CBSEExamChange(e) {
        setCBSEExamID(e);
        setCBSEStudentList({ IsData: true, data: [] });
    }

    function CBSEFinalExamChange(e) {
        setCBSEFinalExamID(e);
    }

    function BindTermExamStudentList() {
        ClearAllGenerateData();
        setTermStudentList({ IsData: false, data: [] });
        setTxtTermStartDate(null);
        setTxtTermEndDate(null);
        if (!StandardDivisionTermExam?.value || !TermExamID?.value) {
            setTermStudentList({ IsData: true, data: [] });
            return;
        }
        if (StandardDivisionTermExam !== null &&
            StandardDivisionTermExam.value !== "" &&
            TermExamID !== null &&
            TermExamID.value !== "") {
            const reqSTDDIV = {
                method: "POST",
                headers: commonService.getHeaders(),
                body: JSON.stringify({
                    StandardID: StandardDivisionTermExam.value.split("|")[0],
                    DivisionID: StandardDivisionTermExam.value.split("|")[1],
                    ExamID: TermExamID.value
                }),
            };
            fetch(
                AppConfigData.APIBasePath + "v1/exam/GetStudentListForTermExam",
                reqSTDDIV
            )
                .then((response) => response.json())
                .then(function (json) {
                    if (json.status_code === 1) {
                        setTermStudentList({ IsData: true, data: json.data.studentList });
                    } else if (json.status_code === 0) {
                        setTermStudentList({ IsData: true, data: [] });
                    } else if (json.status_code === 2) {
                        localStorage.clear();
                        history.push("/");
                    }
                });
        }
    }

    function BindSemesterExamStudentList() {
        ClearAllGenerateData();
        setSemesterStudentList({ IsData: false, data: [] });
        setTxtTermStartDate(null);
        setTxtTermEndDate(null);
        if (!StandardDivisionSemesterExam?.value || !SemesterExamID?.value) {
            setSemesterStudentList({ IsData: true, data: [] });
            return;
        }
        if (StandardDivisionSemesterExam !== null &&
            StandardDivisionSemesterExam.value !== "" &&
            SemesterExamID !== null &&
            SemesterExamID.value !== "") {
            const reqSTDDIV = {
                method: "POST",
                headers: commonService.getHeaders(),
                body: JSON.stringify({
                    StandardID: StandardDivisionSemesterExam.value.split("|")[0],
                    DivisionID: StandardDivisionSemesterExam.value.split("|")[1],
                    ExamID: SemesterExamID.value
                }),
            };
            fetch(
                AppConfigData.APIBasePath + "v1/exam/GetStudentListForSemesterExam",
                reqSTDDIV
            )
                .then((response) => response.json())
                .then(function (json) {
                    if (json.status_code === 1) {
                        setSemesterStudentList({ IsData: true, data: json.data.studentList });
                    } else if (json.status_code === 0) {
                        setSemesterStudentList({ IsData: true, data: [] });
                    } else if (json.status_code === 2) {
                        localStorage.clear();
                        history.push("/");
                    }
                });
        }
    }

    function BindCBSEExamStudentList() {
        ClearAllGenerateData();
        setCBSEStudentList({ IsData: false, data: [] });
        setTxtTermStartDate(null);
        setTxtTermEndDate(null);

        if (!StandardDivisionCBSEExam?.value || !CBSEExamID?.value) {
            setCBSEStudentList({ IsData: true, data: [] });
            return;
        }
        if (StandardDivisionCBSEExam !== null &&
            StandardDivisionCBSEExam.value !== "" &&
            CBSEExamID !== null &&
            CBSEExamID.value !== "") {
            const reqSTDDIV = {
                method: "POST",
                headers: commonService.getHeaders(),
                body: JSON.stringify({
                    StandardID: StandardDivisionCBSEExam.value.split("|")[0],
                    DivisionID: StandardDivisionCBSEExam.value.split("|")[1],
                    ExamID: CBSEExamID.value
                }),
            };
            fetch(
                AppConfigData.APIBasePath + "v1/exam/GetStudentListForCBSEExam",
                reqSTDDIV
            )
                .then((response) => response.json())
                .then(function (json) {
                    if (json.status_code === 1) {
                        setCBSEStudentList({ IsData: true, data: json.data.studentList });
                    } else if (json.status_code === 0) {
                        setCBSEStudentList({ IsData: true, data: [] });
                    } else if (json.status_code === 2) {
                        localStorage.clear();
                        history.push("/");
                    }
                });
        }

    }

    function BindTermFinalExamStudentList() {
        ClearAllGenerateData();
        setTermFinalStudentList({ IsData: false, data: [] });
        setTxtTermStartDate(null);
        setTxtTermEndDate(null);

        if (StandardDivisionTermFinal !== null &&
            StandardDivisionTermFinal.value !== "") {
            const reqSTDDIV = {
                method: "POST",
                headers: commonService.getHeaders(),
                body: JSON.stringify({
                    STDDIVIDS: StandardDivisionTermFinal.value,
                    RequestFrom: "Web",
                }),
            };
            fetch(
                AppConfigData.APIBasePath + "v1/exam/GetStudentListForTermFinalExam",
                reqSTDDIV
            )
                .then((response) => response.json())
                .then(function (json) {
                    if (json.status_code === 1) {
                        setTermFinalStudentList({ IsData: true, data: json.data.studentList });
                    } else if (json.status_code === 0) {
                        setTermFinalStudentList({ IsData: true, data: [] });
                    } else if (json.status_code === 2) {
                        localStorage.clear();
                        history.push("/");
                    }
                });
        }
    }

    function BindSemesterFinalExamStudentList() {
        ClearAllGenerateData();
        setSemesterFinalStudentList({ IsData: false, data: [] });
        setTxtTermStartDate(null);
        setTxtTermEndDate(null);

        if (StandardDivisionSemesterFinal !== null &&
            StandardDivisionSemesterFinal.value !== "") {
            const reqSTDDIV = {
                method: "POST",
                headers: commonService.getHeaders(),
                body: JSON.stringify({
                    STDDIVIDS: StandardDivisionSemesterFinal.value,
                    RequestFrom: "Web",
                }),
            };
            fetch(
                AppConfigData.APIBasePath + "v1/exam/GetStudentListForSemesterFinalExam",
                reqSTDDIV
            )
                .then((response) => response.json())
                .then(function (json) {
                    if (json.status_code === 1) {
                        setSemesterFinalStudentList({ IsData: true, data: json.data.studentList });
                    } else if (json.status_code === 0) {
                        setSemesterFinalStudentList({ IsData: true, data: [] });
                    } else if (json.status_code === 2) {
                        localStorage.clear();
                        history.push("/");
                    }
                });
        }
    }

    function BindCBSEFinalExamStudentList() {
        ClearAllGenerateData();
        setCBSEFinalStudentList({ IsData: false, data: [] });
        setTxtTermStartDate(null);
        setTxtTermEndDate(null);

        if (!StandardDivisionCBSEFinal?.value || !CBSEFinalExamID?.value) {
            setCBSEFinalStudentList({ IsData: true, data: [] });
            return;
        }
        if (StandardDivisionCBSEFinal !== null &&
            StandardDivisionCBSEFinal.value !== "" &&
            CBSEFinalExamID !== null &&
            CBSEFinalExamID.value !== "") {
            const reqSTDDIV = {
                method: "POST",
                headers: commonService.getHeaders(),
                body: JSON.stringify({
                    StandardID: StandardDivisionCBSEFinal.value.split("|")[0],
                    DivisionID: StandardDivisionCBSEFinal.value.split("|")[1],
                    ExamID: CBSEFinalExamID.value
                }),
            };
            fetch(
                AppConfigData.APIBasePath + "v1/exam/GetStudentListForCBSEFinalExam",
                reqSTDDIV
            )
                .then((response) => response.json())
                .then(function (json) {
                    if (json.status_code === 1) {
                        setCBSEFinalStudentList({ IsData: true, data: json.data.studentList });
                    } else if (json.status_code === 0) {
                        setCBSEFinalStudentList({ IsData: true, data: [] });
                    } else if (json.status_code === 2) {
                        localStorage.clear();
                        history.push("/");
                    }
                });
        }
    }

    function fnSaveExamRemarks(item, IsTermFinal, IsSemesterFinal, IsCBSEFinal, Type) {
        setIsDataSaveing(true);
        let lstDetails = [];

        if (Type.toLocaleUpperCase() == "TERM EXAM") {
            if (!IsTermFinal) {
                item.forEach((element) => {
                    let ExamEnrollStdID = element.ExamEnrollStdID;
                    let SubRemark = document.getElementById("SubRemark_" + element.ExamEnrollStdID).value;
                    let ResultRemark = document.getElementById("ResultRemark_" + element.ExamEnrollStdID).value;
                    let AttendanceRemark = document.getElementById("AttendanceRemarks_" + element.ExamEnrollStdID).value;

                    lstDetails.push({
                        ID: ExamEnrollStdID,
                        subRemark: SubRemark,
                        resultRemark: ResultRemark,
                        attendanceRemark: AttendanceRemark
                    });
                });
            } else {
                item.forEach((element) => {
                    let ResultID = element.ResultID;
                    let SubRemark = document.getElementById("SubRemark_" + element.ResultID).value;
                    let ResultRemark = document.getElementById("ResultRemark_" + element.ResultID).value;
                    let AttendanceRemark = document.getElementById("AttendanceRemarks_" + element.ResultID).value;

                    lstDetails.push({
                        ID: ResultID,
                        subRemark: SubRemark,
                        resultRemark: ResultRemark,
                        attendanceRemark: AttendanceRemark
                    });
                });
            }
        }

        if (Type.toLocaleUpperCase() == "SEMESTER EXAM") {
            if (!IsSemesterFinal) {
                item.forEach((element) => {
                    let ExamEnrollStdID = element.ExamEnrollStdID;
                    let SubRemark = document.getElementById("SemesterSubRemark_" + element.ExamEnrollStdID).value;
                    let ResultRemark = document.getElementById("SemesterResultRemark_" + element.ExamEnrollStdID).value;
                    let AttendanceRemark = document.getElementById("SemesterAttendanceRemarks_" + element.ExamEnrollStdID).value;

                    lstDetails.push({
                        ID: ExamEnrollStdID,
                        subRemark: SubRemark,
                        resultRemark: ResultRemark,
                        attendanceRemark: AttendanceRemark
                    });
                });
            }
            else {
                item.forEach((element) => {
                    let ResultID = element.ResultID;
                    let SubRemark = document.getElementById("SemesterFinalSubRemark_" + element.ResultID).value;
                    let ResultRemark = document.getElementById("SemesterFinalResultRemark_" + element.ResultID).value;
                    let AttendanceRemark = document.getElementById("SemesterFinalAttendanceRemarks_" + element.ResultID).value;

                    lstDetails.push({
                        ID: ResultID,
                        subRemark: SubRemark,
                        resultRemark: ResultRemark,
                        attendanceRemark: AttendanceRemark
                    });
                });
            }
        }
        if (Type.toLocaleUpperCase() == "CBSE EXAM") {
            if (!IsCBSEFinal) {
                item.forEach((element) => {
                    let ExamEnrollStdID = element.ExamEnrollStdID;
                    let SubRemark = document.getElementById("CBSESubRemark_" + element.ExamEnrollStdID).value;
                    let ResultRemark = document.getElementById("CBSEResultRemark_" + element.ExamEnrollStdID).value;
                    let AttendanceRemark = document.getElementById("CBSEAttendanceRemarks_" + element.ExamEnrollStdID).value;

                    lstDetails.push({
                        ID: ExamEnrollStdID,
                        subRemark: SubRemark,
                        resultRemark: ResultRemark,
                        attendanceRemark: AttendanceRemark
                    });
                });
            }
            else {
                item.forEach((element) => {
                    let ResultID = element.ResultID;
                    let SubRemark = document.getElementById("CBSEFinalSubRemark_" + element.ResultID).value;
                    let ResultRemark = document.getElementById("CBSEFinalResultRemark_" + element.ResultID).value;
                    let AttendanceRemark = document.getElementById("CBSEFinalAttendanceRemarks_" + element.ResultID).value;

                    lstDetails.push({
                        ID: ResultID,
                        subRemark: SubRemark,
                        resultRemark: ResultRemark,
                        attendanceRemark: AttendanceRemark
                    });
                });
            }
        }

        const reqExam = {
            method: "POST",
            headers: commonService.getHeaders(),
            body: JSON.stringify({
                lstremarkDetails: lstDetails,
                IsTermFinal: IsTermFinal,
                IsSemesterFinal: IsSemesterFinal,
                IsCBSEFinal: IsCBSEFinal,
                ExamType: Type,
                requestFrom: "web"
            }),
        };

        fetch(AppConfigData.APIBasePath + "v1/exam/UpdateRemark", reqExam)
            .then((response) => response.json())
            .then(function (json) {
                if (json.status_code === 1) {
                    setIsDataSaveing(false);
                    alertService.alert({
                        type: AlertType.Success,
                        message: json.message,
                    });
                    ClearAllGenerateData();
                } else if (json.status_code === 0) {
                    alertService.alert({
                        type: AlertType.Error,
                        message: json.message,
                    });
                } else if (json.status_code === 2) {
                    localStorage.clear();
                    history.push("/");
                }
            });
    }

    function ClearAllGenerateData() {
        setTxtTermStartDate(null);
        setTxtTermEndDate(null);
        setTermStudentList({ IsData: true, data: [] });
        setTermFinalStudentList({ IsData: true, data: [] });
        setSemesterStudentList({ IsData: true, data: [] });
        setSemesterFinalStudentList({ IsData: true, data: [] });
        setCBSEStudentList({ IsData: true, data: [] });
        setCBSEFinalStudentList({ IsData: true, data: [] });
    }

    function GetAttendance(StandardDivision, ExamType) {
        if (StandardDivision.value != null && StandardDivision.value != "") {
            const reqAtt = {
                method: "POST",
                headers: commonService.getHeaders(),
                body: JSON.stringify({
                    StandardID: StandardDivision.value.split("|")[0],
                    DivisionID: StandardDivision.value.split("|")[1],
                    StartDate: txtTermStartDate,
                    EndDate: txtTermEndDate
                }),
            };

            fetch(AppConfigData.APIBasePath + "v1/exam/GetStudentAttendanceList", reqAtt)
                .then((response => response.json()))
                .then(function (json) {
                    if (json.status_code === 1) {
                        debugger
                        json.data.studentList.forEach(stu => {
                            const inputs = document.querySelectorAll(`
                                input[data-termstudentid="${stu.StudentID}"],
                                input[data-termfinalstudentid="${stu.StudentID}"],
                                input[data-semesterstudentid="${stu.StudentID}"],
                                input[data-semesterfinalstudentid="${stu.StudentID}"],
                                input[data-cbsestudentid="${stu.StudentID}"],
                                input[data-cbsefinalstudentid="${stu.StudentID}"]
                            `);

                            inputs.forEach(input => {
                                input.value =
                                    `${stu.PresentDays}/${stu.TotalDays}` ||
                                    "";
                            });
                        });

                    } else if (json.status_code === 0) {
                        const inputs = document.querySelectorAll(`
                                input[data-termstudentid],
                                input[data-termfinalstudentid],
                                input[data-semesterstudentid],
                                input[data-semesterfinalstudentid],
                                input[data-cbsestudentid],
                                input[data-cbsefinalstudentid]
                            `);

                        inputs.forEach(input => {
                            input.value = "";
                        });

                    } else if (json.status_code === 2) {
                        localStorage.clear();
                        history.push("/");
                    }
                });
        }
    }

    function GetResultProcessRemarks() {
        const req = {
            method: "POST",
            headers: commonService.getHeaders(),
            body: JSON.stringify({
                multiCategory: "ResultProcessRemark",
                requestFrom: "web"
            })
        };

        fetch(AppConfigData.APIBasePath + "v1/home/get_projectterm_selectbymulticategory", req)
            .then((response) => response.json())
            .then(function (json) {
                if (json.status_code === 1) {
                    let options = [];
                    for (let i = 0; i < json.data.length; i++) {
                        options.push({
                            value: json.data[i].TermID,
                            label: `${json.data[i].Term}`,
                        });
                    }
                    setResultProcessRemarks(options);
                }
                else if (json.status_code === 0) {
                    setResultProcessRemarks([]);
                } else if (json.status_code === 2) {
                    localStorage.clear();
                    history.push("/");
                }
            })
    }

    function LoadTabWiseData(e) {
        if (e.target.getAttribute("data-rr-ui-event-key") === "CBSEScholaticEntry") {
            if (data[0].MemberType.toLowerCase() === "teacher") {
                GetStandardDivisionData();
            }
        }
    }

    const [StandardDivisionStudentData, setStandardDivisionStudentData] = useState({ IsData: true, data: [] });
    const [GradeData, setGradeData] = useState([]);
    const [IsStandardDivisionStudentDataLodding, setIsStandardDivisionStudentDataLodding] = useState(false);

    function fnGetStandaredDivisionWiseStudentData() {
        if (StandardDivisionID && ExamMasterID && StandardSubjectID) {
            setIsStandardDivisionStudentDataLodding(true);
            setStandardDivisionStudentData({ IsData: false, data: [] });
            setGradeData([]);
            const reqSTDDIV = {
                method: "POST",
                headers: commonService.getHeaders(),
                body: JSON.stringify({
                    StandardID: StandardDivisionID.split("|")[0],
                    DivisionID: StandardDivisionID.split("|")[1],
                    SubjectID: StandardSubjectID,
                    ExamID: ExamMasterID
                }),
            };
            fetch(
                AppConfigData.APIBasePath + "v1/exam/GetStandardWiseCBSEScholaticSubjectStudentList",
                reqSTDDIV
            )
                .then((response) => response.json())
                .then(function (json) {
                    setIsStandardDivisionStudentDataLodding(false);
                    if (json.status_code === 1) {

                        let Options = [];
                        if (json.data.gradeList) {
                            for (let i = 0; i < json.data.gradeList.length; i++) {
                                Options.push({
                                    value: json.data.gradeList[i].ScholaticAreaGradeID.toLocaleUpperCase(),
                                    label: json.data.gradeList[i].Name,
                                });
                            }
                        }
                        setGradeData(Options);

                        if (json.data.studentList) {
                            setStandardDivisionStudentData({ IsData: true, data: json.data.studentList })
                        }

                    } else if (json.status_code === 0) {
                        setStandardDivisionStudentData({ IsData: true, data: [] });
                    } else if (json.status_code === 2) {
                        localStorage.clear();
                        history.push("/");
                    }
                });
        }
        else {
            alertService.alert({
                type: AlertType.Error,
                message: "Select all the option",
            });
        }
    }

    React.useEffect(() => {
        if (commonService.getLoginRoleData("Exam", "IsView")) {
            if (data[0].MemberType.toLowerCase() === "teacher") {
                GetStandardWiseExamData();
                GetStandardWiseSubjectData();
                GetStandardDivisionData();
                BindTermExamStudentList();
                GetResultProcessRemarks();
            }
        }
        else {
            history.push("/access");
        }
    }, [StandardDivisionID]);

    function fnStudentGradeChange(e, id) {
        if (e) {
            document.getElementById("Grade_Hidden" + id).value = e;
            document
                .getElementById("Grade_" + id)
                .classList.remove("invalid");
        }
        else {
            document
                .getElementById("Grade_" + id)
                .classList.add("invalid");
        }
    }

    const [IsDataSaveing, setIsDataSaveing] = useState(false);

    function fnSaveCBSEScholaticEntry(item) {
        if (StandardDivisionID && ExamMasterID && StandardSubjectID && item) {
            let AllDataArevalid = true;
            let lstStudent = [];
            item.forEach((element) => {
                let ScholarGradeID = document.getElementById(
                    "Grade_Hidden" + element.StudentID
                ).value
                if (ScholarGradeID) {
                    document
                        .getElementById("Grade_" + element.StudentID)
                        .classList.remove("invalid");
                    lstStudent.push({ StudentID: element.StudentID, ScholarGradeID: ScholarGradeID })
                }
                else {
                    AllDataArevalid = false;
                    document
                        .getElementById("Grade_" + element.StudentID)
                        .classList.add("invalid");
                }
            });

            if (AllDataArevalid) {
                setIsDataSaveing(true)
                let QA = {
                    StandardID: StandardDivisionID.split("|")[0],
                    DivisionID: StandardDivisionID.split("|")[1],
                    SubjectID: StandardSubjectID,
                    ExamID: ExamMasterID,
                    lstStudent: lstStudent,
                };

                const reqExam = {
                    method: "POST",
                    headers: commonService.getHeaders(),
                    body: JSON.stringify(QA),
                };

                fetch(AppConfigData.APIBasePath + "v1/exam/SaveStandardWiseCBSEScholaticSubjectMarks", reqExam)
                    .then((response) => response.json())
                    .then(function (json) {
                        setIsDataSaveing(false)
                        if (json.status_code === 1) {
                            alertService.alert({
                                type: AlertType.Success,
                                message: json.message,
                            });
                        } else if (json.status_code === 0) {
                            alertService.alert({
                                type: AlertType.Error,
                                message: json.message,
                            });
                        } else if (json.status_code === 2) {
                            localStorage.clear();
                            history.push("/");
                        }
                    });
            }
        }
        else {
            alertService.alert({
                type: AlertType.Error,
                message: "Select all the option",
            });
        }

    }

    return (
        <>
            <h1 className="page-header my-4">{commonService.LabelDisplayText("MenuExam")}</h1>
            <div className="background-theme-color sticky-top">
                <div className="search-top-section">
                    <div className="row">
                        <div className="col-lg-12 col-xl-7">
                            <div className="header-search-area">
                                <input
                                    type="text"
                                    className=""
                                    placeholder={commonService.LabelDisplayText("SearchText")}
                                    onChange={(e) => setTxtSearch(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-lg-12 col-xl-5 mt-3 mt-xl-0">
                            <div className="search-right-cal d-flex align-items-center">
                                <div className="header-date-area w-100 mr-3">
                                    <div className="d-flex align-items-center">
                                        <label className="from-date">
                                            {commonService.LabelDisplayText("DatepickerFrom")}
                                        </label>
                                        <DatePicker
                                            className="datepicker"
                                            selected={txtStartDate}
                                            dateFormat={data[0].DateFormat_Term}
                                            onChange={(date) => setTxtStartDate(date)}
                                            placeholderText={data[0].DateFormat_Term}
                                        />
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <label className="from-date">
                                            {commonService.LabelDisplayText("DatepickerTo")}
                                        </label>
                                        <DatePicker
                                            className="datepicker"
                                            selected={txtEndDate}
                                            minDate={txtStartDate && txtStartDate}
                                            dateFormat={data[0].DateFormat_Term}
                                            onChange={(date) => setTxtEndDate(date)}
                                            placeholderText={data[0].DateFormat_Term}
                                        />
                                    </div>
                                </div>
                                <div className="right-icon-cal d-flex align-items-center">
                                    {IsListDateLodding === false ? (
                                        <div
                                            className="search-icon-img pointer-cursor"
                                            onClick={() => BindExamList()}
                                        >
                                            <i className="fa-regular fa-magnifying-glass"></i>
                                        </div>
                                    ) : (
                                        <div className="search-icon-img pointer-cursor">
                                            <Spinner animation="border" size="sm" variant="primary" />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="search-result-block">
                    <span>
                        Result For{" "}
                        <span>
                            {txtSearch +
                                " From : " +
                                commonService.getDateInFormat(txtStartDate) +
                                " To : " +
                                commonService.getDateInFormat(txtEndDate)}
                        </span>
                    </span>
                </div>
            </div>
            <Tabs
                defaultActiveKey={"Today"}
                transition={false}
                id="noanim-tab-example"
                className="mb-3 timetable-liveclass"
                onClick={(e) => LoadTabWiseData(e)}
            >

                <Tab eventKey="Today" title={commonService.LabelDisplayText("TodayExam")}>
                    <div className={Exam.data.length === 0 ? "" : "row"}>
                        {!Exam.IsData ? (
                            <_Skeleton type={_SkeletonType.Exam} count={1} lineheight={40} />
                        ) : Exam.data.length === 0 ? (
                            <_NoDataFound fontsize={"300px"} />
                        ) : (
                            Exam.data.map(
                                (item, index) =>
                                    commonService.getDateInDBFormat(item.DateOfExam) === commonService.getDateInDBFormat(new Date()) && new Date(item.EndDateTime) >= new Date() && (
                                        <div
                                            className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 exam-section-area mb-3"
                                            key={index}
                                        >
                                            <a
                                                className={`pointer-cursor`}
                                                onClick={(e) => ViewExamDetailsPage(item)}
                                            >
                                                <div className="section">
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <label>
                                                            {commonService.getDateInFormat(item.DateOfExam)}
                                                        </label>
                                                        <label>{commonService.LabelDisplayText("TotalMark")} {item.TotakMarks}</label>
                                                    </div>
                                                    <h3 className="science-text">
                                                        <div className="d-flex align-items-center justify-content-center">{item.IsOnlineExam ? (
                                                            <i className="fa-solid fa-laptop-mobile mr-2"></i>
                                                        ) : (
                                                            <i className="fa-regular fa-school mr-2"></i>
                                                        )}
                                                            {item.SubjectName}</div>
                                                        <label className="d-flex align-items-center justify-content-center">{item.ExamTypeAndPaperType}</label>
                                                    </h3>
                                                    <div className="d-flex justify-content-between align-items-cente ">
                                                        {data[0].MemberType.toLowerCase() !== "student" ? (
                                                            <label className="mark-label float-left">
                                                                {commonService.LabelDisplayText("STD")} : {item.StandardName} - {item.ExamName}
                                                            </label>
                                                        ) : (
                                                            <label className="mark-label float-left">
                                                                {item.ExamName}
                                                            </label>
                                                        )}
                                                        <label>{ChangeExamTypeDisplayName(item.ExamOfTypeTerm)}</label>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    )
                            )
                        )}
                    </div>
                </Tab>

                <Tab eventKey="UpcommigExam" title={commonService.LabelDisplayText("UpcomingExam")}>
                    <div className={Exam.data.length === 0 ? "" : "row"}>
                        {!Exam.IsData ? (
                            <_Skeleton type={_SkeletonType.Exam} count={1} lineheight={40} />
                        ) : Exam.data.length === 0 ? (
                            <_NoDataFound fontsize={"300px"} />
                        ) : (
                            Exam.data.map(
                                (item, index) =>
                                    new Date(item.DateOfExam) >= new Date() && (
                                        <div
                                            className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 exam-section-area mb-3"
                                            key={index}
                                        >
                                            <a
                                                className={`pointer-cursor`}
                                                onClick={(e) => ViewExamDetailsPage(item)}
                                            >
                                                <div className="section">
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <label>
                                                            {commonService.getDateInFormat(item.DateOfExam)}
                                                        </label>
                                                        <label>{commonService.LabelDisplayText("TotalMark")} {item.TotakMarks}</label>
                                                    </div>
                                                    <h3 className="science-text">
                                                        <div className="d-flex align-items-center justify-content-center">{item.IsOnlineExam ? (
                                                            <i className="fa-solid fa-laptop-mobile mr-2"></i>
                                                        ) : (
                                                            <i className="fa-regular fa-school mr-2"></i>
                                                        )}
                                                            {item.SubjectName}</div>
                                                        <label className="d-flex align-items-center justify-content-center">{item.ExamTypeAndPaperType}</label>
                                                    </h3>
                                                    <div className="d-flex justify-content-between align-items-cente ">
                                                        {data[0].MemberType.toLowerCase() !== "student" ? (
                                                            <label className="mark-label float-left">
                                                                {commonService.LabelDisplayText("STD")} : {item.StandardName} - {item.ExamName}
                                                            </label>
                                                        ) : (
                                                            <label className="mark-label float-left">
                                                                {item.ExamName}
                                                            </label>
                                                        )}
                                                        <label>{ChangeExamTypeDisplayName(item.ExamOfTypeTerm)}</label>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    )
                            )
                        )}
                    </div>
                </Tab>

                <Tab eventKey="CompletedExam" title={commonService.LabelDisplayText("CompletedExam")}>
                    <div className={Exam.data.length === 0 ? "" : "row"}>
                        {!Exam.IsData ? (
                            <_Skeleton type={_SkeletonType.Exam} count={1} lineheight={40} />
                        ) : Exam.data.length === 0 ? (
                            <_NoDataFound fontsize={"300px"} />
                        ) : (
                            Exam.data.map(
                                (item, index) =>
                                    new Date(item.EndDateTime) <= new Date() && (
                                        <div
                                            className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 exam-section-area mb-3"
                                            key={index}
                                        >
                                            <a
                                                className={`pointer-cursor`}
                                                onClick={(e) => ViewExamDetailsPage(item)}
                                            >
                                                <div className="section">
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <label>
                                                            {commonService.getDateInFormat(item.DateOfExam)}
                                                        </label>
                                                        <label>{commonService.LabelDisplayText("TotalMark")} {item.TotakMarks}</label>
                                                    </div>
                                                    <h3 className="science-text">
                                                        <div className="d-flex align-items-center justify-content-center">{item.IsOnlineExam ? (
                                                            <i className="fa-solid fa-laptop-mobile mr-2"></i>
                                                        ) : (
                                                            <i className="fa-regular fa-school mr-2"></i>
                                                        )}
                                                            {item.SubjectName}</div>
                                                        <label className="d-flex align-items-center justify-content-center">{item.ExamTypeAndPaperType}</label>
                                                    </h3>


                                                    <div className="d-flex justify-content-between align-items-cente ">
                                                        {data[0].MemberType.toLowerCase() !== "student" ? (
                                                            <label className="mark-label float-left">
                                                                {commonService.LabelDisplayText("STD")} : {item.StandardName} - {item.ExamName}
                                                            </label>
                                                        ) : (
                                                            <label className="mark-label float-left">
                                                                {item.ExamName}
                                                            </label>
                                                        )}

                                                        <label>{ChangeExamTypeDisplayName(item.ExamOfTypeTerm)}</label>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    )
                            )
                        )}
                    </div>
                </Tab>

                {data[0].MemberType.toLowerCase() === "teacher" &&
                    <Tab eventKey="ResultSheet" title={commonService.LabelDisplayText("ResultSheet")}>
                        <div className={ResultSheetData.data.length === 0 ? "" : "row"}>
                            {!ResultSheetData.IsData ? (
                                <_Skeleton type={_SkeletonType.Exam} count={1} lineheight={40} />
                            ) : ResultSheetData.data.length === 0 ? (
                                <_NoDataFound fontsize={"300px"} />
                            ) : (
                                ResultSheetData.data.map((item, index) => {
                                    let hrefLink = "";
                                    if (item.ExamType.toLowerCase() === "weekly test") {
                                        hrefLink = AppConfigData.ERPBasePath + "mobile_api/rptPDF_examwiseresultsummary?StandardID=" + item.StandardID + "&ExamID=" + item.ExamID + "&DivisionID=" + item.DivisionID + "&InstituteID="
                                            + item.InstituteID + "&ClientID=" + item.ClientID + "&TermYearID=" + item.BatchID + "&ShiftID=" + item.ShiftID;
                                    }
                                    else if (item.ExamType.toLowerCase() === "cbse exam") {
                                        hrefLink = AppConfigData.ERPBasePath + "mobile_api/rptPDF_ExamWiseResultSheetData?StandardID=" + item.StandardID + "&ExamID=" + item.ExamID + "&DivisionID=" + item.DivisionID + "&InstituteID="
                                            + item.InstituteID + "&ClientID=" + item.ClientID + "&TermYearID=" + item.BatchID + "&ShiftID=" + item.ShiftID;
                                    }
                                    else if (item.ExamType.toLowerCase() === "term exam") {
                                        hrefLink = AppConfigData.ERPBasePath + "mobile_api/ExamWiseResultSheet_reportdataPDF?StandardID=" + item.StandardID + "&ExamID=" + item.ExamID + "&DivisionID=" + item.DivisionID + "&InstituteID="
                                            + item.InstituteID + "&ClientID=" + item.ClientID + "&TermYearID=" + item.BatchID + "&ShiftID=" + item.ShiftID;
                                    }
                                    else if (item.ExamType.toLowerCase() === "semester exam") {
                                        hrefLink = AppConfigData.ERPBasePath + "mobile_api/rptpdf_semesterexamwiseresultsheet?StandardID=" + item.StandardID + "&ExamID=" + item.ExamID + "&DivisionID=" + item.DivisionID + "&InstituteID="
                                            + item.InstituteID + "&ClientID=" + item.ClientID + "&TermYearID=" + item.BatchID + "&ShiftID=" + item.ShiftID;
                                    }

                                    return <div
                                        className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 exam-section-area mb-3"
                                        key={index}
                                    >
                                        <a
                                            className={`pointer-cursor`}
                                            onClick={(e) => GetResultSheetPath(hrefLink)}
                                            target={"_blank"}
                                        >
                                            <div className="section">
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <label>
                                                        {commonService.getDateInFormat(item.StartDate)}
                                                    </label>
                                                    <label>
                                                        {commonService.getDateInFormat(item.Enddate)}
                                                    </label>
                                                </div>
                                                <h3 className="science-text">
                                                    <div className="d-flex align-items-center justify-content-center">
                                                        {item.ExamName}</div>
                                                </h3>
                                                <div className="d-flex justify-content-between align-items-cente ">
                                                    <label className="mark-label float-left">
                                                        {commonService.LabelDisplayText("STD")} : {item.Standard} - {item.Division}
                                                    </label>
                                                    <label>{ChangeExamTypeDisplayName(item.ExamType)}</label>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                })
                            )}
                        </div>
                    </Tab>
                }

                {
                    data[0].MemberType.toLowerCase() === "teacher" && commonService.getLoginRoleData("Scholatic Entry", "IsCreate") &&
                    <Tab eventKey="CBSEScholaticEntry" title={commonService.LabelDisplayText("CBSEScholaticEntry")} >
                        <div className="background-theme-color  notice-circular-event-searchbar attendence-header-section">
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
                                    <div className="posting-section  align-items-center justify-content-between sticky-top attendence-search-section  first-attendence-section">
                                        <div className="row align-items-center m-0 selection-attendence-row">
                                            <div className="col-12 p-0">
                                                <div className="row">
                                                    <div className="col-4">
                                                        <Select
                                                            className="attendence-select"
                                                            placeholder={commonService.LabelDisplayText("SelectStandardDivision")}
                                                            options={TeacherStdDiv}
                                                            onChange={(e) => { StandardDivisionChange(e) }}
                                                            value={TeacherStdDiv.find(
                                                                (obj) =>
                                                                    obj.value.toLocaleUpperCase() ===
                                                                    StandardDivisionID
                                                            )}
                                                        />
                                                    </div>
                                                    <div className="col-4">
                                                        <Select
                                                            className="attendence-select"
                                                            placeholder={commonService.LabelDisplayText("SelectExam")}
                                                            options={ExamMaster}
                                                            onChange={(e) => { ExamMasterChange(e) }}
                                                            value={ExamMaster.find(
                                                                (obj) =>
                                                                    obj.value.toLocaleUpperCase() ===
                                                                    ExamMasterID
                                                            )}
                                                        />
                                                    </div>
                                                    <div className="col-3">
                                                        <Select
                                                            className="attendence-select"
                                                            placeholder={commonService.LabelDisplayText("SelectSubject")}
                                                            options={StandardSubject}
                                                            onChange={(e) => { StandardSubjectChange(e) }}
                                                            value={StandardSubject.find(
                                                                (obj) =>
                                                                    obj.value.toLocaleUpperCase() ===
                                                                    StandardSubjectID
                                                            )}
                                                        />
                                                    </div>
                                                    <div className="col-1">
                                                        {IsStandardDivisionStudentDataLodding === false ? (
                                                            <div
                                                                className="search-icon-img pointer-cursor attendence-serach-img"
                                                                onClick={() => fnGetStandaredDivisionWiseStudentData()}
                                                            >
                                                                <i className="fa-regular fa-magnifying-glass"></i>
                                                            </div>
                                                        ) : (
                                                            <div className="search-icon-img pointer-cursor attendence-serach-img">
                                                                <Spinner
                                                                    animation="border"
                                                                    size="sm"
                                                                    variant="primary"
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {!StandardDivisionStudentData.IsData ? (
                                <div className="row col-12">
                                    <_Skeleton
                                        type={_SkeletonType.Table}
                                        count={4}
                                        lineheight={30}
                                    />
                                </div>
                            ) : StandardDivisionStudentData.data.length === 0 ? (
                                <div className="col-12 mt-5">
                                    <_NoDataFound fontsize={"150px"} />
                                </div>
                            ) : (
                                <div>
                                    <Table responsive className="mark-entry-table">
                                        <thead>
                                            <tr>
                                                <th className="w-100px">{commonService.LabelDisplayText("Roll")}</th>
                                                <th className="w-100px">{commonService.LabelDisplayText("GR")}</th>
                                                <th className="w-100px">{commonService.LabelDisplayText("Seat")}</th>
                                                <th>{commonService.LabelDisplayText("StudentName")}</th>
                                                <th className="w-150px">{commonService.LabelDisplayText("Grade")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                StandardDivisionStudentData.data.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{item.RollNo}</td>
                                                        <td>{item.GRNo}</td>
                                                        <td>{item.ExamSeatNo}</td>
                                                        <td>{item.StudentName}</td>
                                                        <td>
                                                            <Select
                                                                id={"Grade_" + item.StudentID}
                                                                className="attendence-select"
                                                                placeholder={commonService.LabelDisplayText("Choose")}
                                                                options={GradeData}
                                                                onChange={(e) => fnStudentGradeChange(
                                                                    e.value,
                                                                    item.StudentID
                                                                )}
                                                                value={GradeData.find(
                                                                    (obj) =>
                                                                        obj.value.toLocaleUpperCase() === (item.ScholarGradeID ? item.ScholarGradeID : "").toLocaleUpperCase())}
                                                            />
                                                            <input
                                                                type="hidden"
                                                                id={"Grade_Hidden" + item.StudentID}
                                                                value={(item.ScholarGradeID ? item.ScholarGradeID : "").toLocaleUpperCase()}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </Table>
                                    {
                                        commonService.getLoginRoleData("Scholatic Entry", "IsCreate") ?
                                            IsDataSaveing === false ?
                                                <a
                                                    onClick={(e) =>
                                                        fnSaveCBSEScholaticEntry(StandardDivisionStudentData.data)
                                                    }
                                                    className="btn btn-primary"
                                                >
                                                    {commonService.LabelDisplayText("Save")}
                                                </a>
                                                :
                                                <a
                                                    className="btn btn-primary"
                                                >
                                                    <Spinner animation="border" size="sm" /> {commonService.LabelDisplayText("Saving")}
                                                </a>
                                            : <></>
                                    }
                                </div>

                            )}
                        </div>
                    </Tab>
                }

                {
                    data[0].MemberType.toLowerCase() === "teacher" && commonService.getLoginRoleData("Exam Remark", "IsCreate") &&
                    <Tab eventKey="Remark" title={commonService.LabelDisplayText("Remarks")}>
                        <Tabs defaultActiveKey="TermWiseRemark"
                            id="uncontrolled-tab-example"
                            className="mb-3 exam-result-tabs chapter-detail-tabs">

                            <Tab eventKey="TermWiseRemark" title="Term Exam Wise">
                                <div className="background-theme-color  notice-circular-event-searchbar attendence-header-section">
                                    <div className="row">
                                        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
                                            <div className="posting-section  align-items-center justify-content-between sticky-top attendence-search-section  first-attendence-section">
                                                <div className="row align-items-center m-0 selection-attendence-row">
                                                    <div className="row">
                                                        <div className="col-12 p-0">
                                                            <div className="row">
                                                                <div className="col-6">
                                                                    <Select
                                                                        className="attendence-select"
                                                                        placeholder={commonService.LabelDisplayText("SelectStandardDivision")}
                                                                        options={TeacherStdDiv}
                                                                        onChange={(e) => { GetTermExamByStandardDivisionID(e) }}
                                                                        value={StandardDivisionTermExam}
                                                                    />
                                                                </div>
                                                                <div className="col-5 pr-0">
                                                                    <Select
                                                                        className="attendence-select"
                                                                        placeholder={commonService.LabelDisplayText("SelectExam")}
                                                                        options={TermExamName}
                                                                        onChange={(e) => { TermExamChange(e) }}
                                                                        value={TermExamID}
                                                                    />
                                                                </div>
                                                                <div className="col-1  pr-0">
                                                                    <Button class="btn btn-primary align-items-center justify-content-center"
                                                                        onClick={() => BindTermExamStudentList()}
                                                                    >Get Data</Button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {!TermStudentList.IsData ? (
                                        <div className="row col-12">
                                            <_Skeleton
                                                type={_SkeletonType.Table}
                                                count={4}
                                                lineheight={30}
                                            />
                                        </div>
                                    ) : TermStudentList.data.length === 0 ? (
                                        <div className="col-12 mt-5">
                                            <_NoDataFound fontsize={"150px"} />
                                        </div>
                                    ) : (
                                        <>
                                            {TermStudentList.data.filter(x => x.IsPublish).length === 0 ? (
                                                <>
                                                    <div className="row">
                                                        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-6 mb-3">
                                                            <div className="posting-section  align-items-center justify-content-between ">
                                                                <div className="d-flex align-items-center">
                                                                    <div className="header-date-area w-100 mr-3">
                                                                        <div className="d-flex align-items-center">
                                                                            <label className="from-date">
                                                                                {commonService.LabelDisplayText("DatepickerFrom")}
                                                                            </label>
                                                                            <DatePicker
                                                                                className="datepicker"
                                                                                selected={txtTermStartDate}
                                                                                dateFormat={data[0].DateFormat_Term}
                                                                                onChange={(date) => setTxtTermStartDate(date)}
                                                                                placeholderText={data[0].DateFormat_Term}
                                                                            />
                                                                        </div>
                                                                        <div className="d-flex align-items-center">
                                                                            <label className="from-date">
                                                                                {commonService.LabelDisplayText("DatepickerTo")}
                                                                            </label>
                                                                            <DatePicker
                                                                                className="datepicker"
                                                                                selected={txtTermEndDate}
                                                                                minDate={txtTermStartDate}
                                                                                dateFormat={data[0].DateFormat_Term}
                                                                                onChange={(date) => setTxtTermEndDate(date)}
                                                                                placeholderText={data[0].DateFormat_Term}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="right-icon-cal d-flex align-items-center">
                                                                        <div className="d-flex align-items-center">
                                                                            <Button class="btn btn-primary align-items-center justify-content-center"
                                                                                onClick={() => GetAttendance(StandardDivisionTermExam, "TERM EXAM")}
                                                                            >Attendance</Button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <Table responsive className="mark-entry-table">
                                                        <thead>
                                                            <tr>
                                                                <th className="w-75px">{commonService.LabelDisplayText("Seat")}</th>
                                                                <th className="w-350px">{commonService.LabelDisplayText("StudentName")}</th>
                                                                <th className="text-center w-100px">{commonService.LabelDisplayText("TotalMark")}</th>
                                                                <th className="text-center w-100px">{commonService.LabelDisplayText("NetObtainedMarks")}</th>
                                                                <th className="text-center w-100px">{commonService.LabelDisplayText("Result")}</th>
                                                                <th className="text-center">{commonService.LabelDisplayText("SubRemark")}</th>
                                                                <th className="text-center">{commonService.LabelDisplayText("ResultRemark")}</th>
                                                                <th className="text-center">{commonService.LabelDisplayText("AttendanceRemark")}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {TermStudentList.data.map((item, index) => (
                                                                item.Result !== null && item.Result !== "" && (
                                                                    <>
                                                                        <tr key={item.StudentID} id={item.ExamEnrollStdID}>
                                                                            <td className="text-center">{item.SeatNo}</td>
                                                                            <td>{item.StudentFullName}</td>
                                                                            <td className="text-center">{item.TotalMarks}</td>
                                                                            <td className="text-center">{item.TotalObtainedMarks}</td>
                                                                            <td className="text-center"><b>{item.ResultType_Term}</b></td>
                                                                            <td className="w-150px">
                                                                                <input
                                                                                    list="Remarkslist"
                                                                                    type="text"
                                                                                    id={
                                                                                        "SubRemark_" +
                                                                                        item.ExamEnrollStdID
                                                                                    }
                                                                                    className="title-textbox"
                                                                                    defaultValue={item.SubRemark}
                                                                                />

                                                                            </td>
                                                                            <td className="w-150px">
                                                                                <input
                                                                                    type="text"
                                                                                    id={
                                                                                        "ResultRemark_" +
                                                                                        item.ExamEnrollStdID
                                                                                    }
                                                                                    className="title-textbox"
                                                                                    defaultValue={item.ResultRemark}
                                                                                />
                                                                            </td>
                                                                            <td className="w-150px">
                                                                                <input
                                                                                    type="text"
                                                                                    id={
                                                                                        "AttendanceRemarks_" +
                                                                                        item.ExamEnrollStdID
                                                                                    }
                                                                                    data-termstudentid={item.StudentID}
                                                                                    className="title-textbox"
                                                                                    defaultValue={item.AttendanceRemarks}
                                                                                />
                                                                            </td>
                                                                        </tr>
                                                                    </>
                                                                )
                                                            ))}
                                                        </tbody>
                                                    </Table>

                                                    {
                                                        IsDataSaveing === false ?
                                                            <a
                                                                onClick={(e) =>
                                                                    fnSaveExamRemarks(TermStudentList.data, false, false, false, "TERM EXAM")
                                                                }
                                                                className="btn btn-primary"
                                                            >
                                                                {commonService.LabelDisplayText("Save")}
                                                            </a>
                                                            :
                                                            <a
                                                                className="btn btn-primary"
                                                            >
                                                                <Spinner animation="border" size="sm" /> {commonService.LabelDisplayText("Saving")}
                                                            </a>
                                                    }
                                                </>
                                            ) : (
                                                <div className="error-message text-center"> This Exam is Already Publish Yo Cant Do It.</div>
                                            )}
                                        </>
                                    )}
                                </div>
                            </Tab>
                            <Tab eventKey="TermFinalRemark" title="Term Final">
                                <div className="background-theme-color  notice-circular-event-searchbar attendence-header-section">
                                    <div className="row">
                                        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
                                            <div className="posting-section  align-items-center justify-content-between sticky-top attendence-search-section  first-attendence-section">
                                                <div className="row align-items-center m-0 selection-attendence-row">
                                                    <div className="col-12 p-0">
                                                        <div className="row">
                                                            <div className="col-4">
                                                                <Select
                                                                    className="attendence-select"
                                                                    placeholder={commonService.LabelDisplayText("SelectStandardDivision")}
                                                                    options={TeacherStdDiv}
                                                                    onChange={(e) => { GetTermFinalExamByStandardDivisionID(e) }}
                                                                    value={StandardDivisionTermFinal}
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                <div className="btn-group gap-2 multiple" role="group">
                                                                    {TermFinalExamName.map((exam) => (
                                                                        <button
                                                                            key={exam.value}
                                                                            type="button"
                                                                            className="btn btn-light ml-2"
                                                                        >
                                                                            {exam.label}
                                                                        </button>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                            <div className="col-2  pr-0">
                                                                <Button class="btn btn-primary align-items-center justify-content-center"
                                                                    onClick={() => BindTermFinalExamStudentList()}
                                                                >Get Data</Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {!TermFinalStudentList.IsData ? (
                                        <div className="row col-12">
                                            <_Skeleton
                                                type={_SkeletonType.Table}
                                                count={4}
                                                lineheight={30}
                                            />
                                        </div>
                                    ) : TermFinalStudentList.data.length === 0 ? (
                                        <div className="col-12 mt-5">
                                            <_NoDataFound fontsize={"150px"} />
                                        </div>
                                    ) : (
                                        <>
                                            {TermFinalStudentList.data.filter(x => x.IsPublish).length === 0 ? (
                                                <>
                                                    <div className="row">
                                                        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-6 mb-3">
                                                            <div className="posting-section  align-items-center justify-content-between   ">
                                                                <div className="d-flex align-items-center">
                                                                    <div className="header-date-area w-100 mr-3">
                                                                        <div className="d-flex align-items-center">
                                                                            <label className="from-date">
                                                                                {commonService.LabelDisplayText("DatepickerFrom")}
                                                                            </label>
                                                                            <DatePicker
                                                                                className="datepicker"
                                                                                selected={txtTermStartDate}
                                                                                dateFormat={data[0].DateFormat_Term}
                                                                                onChange={(date) => setTxtTermStartDate(date)}
                                                                                placeholderText={data[0].DateFormat_Term}
                                                                            />
                                                                        </div>
                                                                        <div className="d-flex align-items-center">
                                                                            <label className="from-date">
                                                                                {commonService.LabelDisplayText("DatepickerTo")}
                                                                            </label>
                                                                            <DatePicker
                                                                                className="datepicker"
                                                                                selected={txtTermEndDate}
                                                                                minDate={txtTermStartDate}
                                                                                dateFormat={data[0].DateFormat_Term}
                                                                                onChange={(date) => setTxtTermEndDate(date)}
                                                                                placeholderText={data[0].DateFormat_Term}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="right-icon-cal d-flex align-items-center">
                                                                        <div className="d-flex align-items-center">
                                                                            <Button class="btn btn-primary align-items-center justify-content-center"
                                                                                onClick={() => GetAttendance(StandardDivisionTermFinal, "TERM FINAL EXAM")}
                                                                            >Attendance</Button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <Table responsive className="mark-entry-table">
                                                        <thead>
                                                            <tr>
                                                                <th className="w-75px">{commonService.LabelDisplayText("Seat")}</th>
                                                                <th className="w-350px">{commonService.LabelDisplayText("StudentName")}</th>
                                                                <th className="text-center w-100px">{commonService.LabelDisplayText("TotalMark")}</th>
                                                                <th className="text-center w-100px">{commonService.LabelDisplayText("NetObtainedMarks")}</th>
                                                                <th className="text-center w-100px">{commonService.LabelDisplayText("Result")}</th>
                                                                <th className="text-center">{commonService.LabelDisplayText("SubRemark")}</th>
                                                                <th className="text-center">{commonService.LabelDisplayText("ResultRemark")}</th>
                                                                <th className="text-center">{commonService.LabelDisplayText("AttendanceRemark")}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {TermFinalStudentList.data.map((item, index) => (
                                                                item.Result !== null && item.Result !== "" && (
                                                                    <>
                                                                        <tr key={item.StudentID} id={item.ResultID}>
                                                                            <td className="text-center">{item.SeatNo}</td>
                                                                            <td>{item.StudentFullName}</td>
                                                                            <td className="text-center">{item.TotalMarks}</td>
                                                                            <td className="text-center">{item.Obtained}</td>
                                                                            <td className="text-center"><b>{item.Result_Term}</b></td>
                                                                            <td className="w-150px">
                                                                                <input
                                                                                    type="text"
                                                                                    list="Remarkslist"
                                                                                    id={
                                                                                        "SubRemark_" +
                                                                                        item.ResultID
                                                                                    }
                                                                                    className="title-textbox"
                                                                                    defaultValue={item.SubRemark}
                                                                                /></td>
                                                                            <td className="w-150px">
                                                                                <input
                                                                                    type="text"
                                                                                    id={
                                                                                        "ResultRemark_" +
                                                                                        item.ResultID
                                                                                    }
                                                                                    className="title-textbox"
                                                                                    defaultValue={item.ResultRemark}
                                                                                />
                                                                            </td>
                                                                            <td className="w-150px">
                                                                                <input
                                                                                    type="text"
                                                                                    id={
                                                                                        "AttendanceRemarks_" +
                                                                                        item.ResultID
                                                                                    }
                                                                                    data-termfinalstudentid={item.StudentID}
                                                                                    className="title-textbox"
                                                                                    defaultValue={item.AttendanceRemarks}
                                                                                />
                                                                            </td>
                                                                        </tr>
                                                                    </>
                                                                )
                                                            ))}
                                                        </tbody>
                                                    </Table>

                                                    {
                                                        IsDataSaveing === false ?
                                                            <a
                                                                onClick={(e) =>
                                                                    fnSaveExamRemarks(TermFinalStudentList.data, true, false, false, "TERM EXAM")
                                                                }
                                                                className="btn btn-primary"
                                                            >
                                                                {commonService.LabelDisplayText("Save")}
                                                            </a>
                                                            :
                                                            <a
                                                                className="btn btn-primary"
                                                            >
                                                                <Spinner animation="border" size="sm" /> {commonService.LabelDisplayText("Saving")}
                                                            </a>
                                                    }
                                                </>
                                            ) : (
                                                <div className="error-message text-center"> This Exam is Already Publish Yo Cant Do It.</div>
                                            )}
                                        </>
                                    )}
                                </div>
                            </Tab>
                            <Tab eventKey="SemesterWiseRemark" title="Semester Exam Wise">
                                <div className="background-theme-color  notice-circular-event-searchbar attendence-header-section">
                                    <div className="row">
                                        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
                                            <div className="posting-section  align-items-center justify-content-between sticky-top attendence-search-section  first-attendence-section">
                                                <div className="row align-items-center m-0 selection-attendence-row">
                                                    <div className="col-12 p-0">
                                                        <div className="row">
                                                            <div className="col-4">
                                                                <Select
                                                                    className="attendence-select"
                                                                    placeholder={commonService.LabelDisplayText("SelectStandardDivision")}
                                                                    options={TeacherStdDiv}
                                                                    onChange={(e) => { GetSemesterExamByStandardDivisionID(e) }}
                                                                    value={StandardDivisionSemesterExam}
                                                                />
                                                            </div>
                                                            <div className="col-4">
                                                                <Select
                                                                    className="attendence-select"
                                                                    placeholder={commonService.LabelDisplayText("SelectExam")}
                                                                    options={SemesterExamName}
                                                                    onChange={(e) => { SemesterExamChange(e) }}
                                                                    value={SemesterExamID}
                                                                />
                                                            </div>
                                                            <div className="col-2 pr-0">
                                                                <Button class="btn btn-primary align-items-center justify-content-center"
                                                                    onClick={() => BindSemesterExamStudentList()}
                                                                >Get Data</Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {!SemesterStudentList.IsData ? (
                                        <div className="row col-12">
                                            <_Skeleton
                                                type={_SkeletonType.Table}
                                                count={4}
                                                lineheight={30}
                                            />
                                        </div>
                                    ) : SemesterStudentList.data.length === 0 ? (
                                        <div className="col-12 mt-5">
                                            <_NoDataFound fontsize={"150px"} />
                                        </div>
                                    ) : (
                                        <>
                                            {SemesterStudentList.data.filter(x => x.IsPublish).length === 0 ? (
                                                <>
                                                    <div className="row">
                                                        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-6 mb-3">
                                                            <div className="posting-section  align-items-center justify-content-between  ">
                                                                <div className="d-flex align-items-center">
                                                                    <div className="header-date-area w-100 mr-3">
                                                                        <div className="d-flex align-items-center">
                                                                            <label className="from-date">
                                                                                {commonService.LabelDisplayText("DatepickerFrom")}
                                                                            </label>
                                                                            <DatePicker
                                                                                className="datepicker"
                                                                                selected={txtTermStartDate}
                                                                                dateFormat={data[0].DateFormat_Term}
                                                                                onChange={(date) => setTxtTermStartDate(date)}
                                                                                placeholderText={data[0].DateFormat_Term}
                                                                            />
                                                                        </div>
                                                                        <div className="d-flex align-items-center">
                                                                            <label className="from-date">
                                                                                {commonService.LabelDisplayText("DatepickerTo")}
                                                                            </label>
                                                                            <DatePicker
                                                                                className="datepicker"
                                                                                selected={txtTermEndDate}
                                                                                minDate={txtTermStartDate}
                                                                                dateFormat={data[0].DateFormat_Term}
                                                                                onChange={(date) => setTxtTermEndDate(date)}
                                                                                placeholderText={data[0].DateFormat_Term}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="right-icon-cal d-flex align-items-center">
                                                                        <div className="d-flex align-items-center">
                                                                            <Button class="btn btn-primary align-items-center justify-content-center"
                                                                                onClick={() => GetAttendance(StandardDivisionSemesterExam, "SEMESTER EXAM")}
                                                                            >Attendance</Button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <Table responsive className="mark-entry-table">
                                                        <thead>
                                                            <tr>
                                                                <th className="w-75px">{commonService.LabelDisplayText("Seat")}</th>
                                                                <th className="w-350px">{commonService.LabelDisplayText("StudentName")}</th>
                                                                <th className="text-center w-100px">{commonService.LabelDisplayText("TotalMark")}</th>
                                                                <th className="text-center w-100px">{commonService.LabelDisplayText("NetObtainedMarks")}</th>
                                                                <th className="text-center w-100px">{commonService.LabelDisplayText("Result")}</th>
                                                                <th className="text-center">{commonService.LabelDisplayText("SubRemark")}</th>
                                                                <th className="text-center">{commonService.LabelDisplayText("ResultRemark")}</th>
                                                                <th className="text-center">{commonService.LabelDisplayText("AttendanceRemark")}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {SemesterStudentList.data.map((item) => (
                                                                item.Result !== null && item.Result !== "" && (
                                                                    <>
                                                                        <tr key={item.StudentID} id={item.ExamEnrollStdID}>
                                                                            <td className="text-center">{item.SeatNo}</td>
                                                                            <td>{item.StudentFullName}</td>
                                                                            <td className="text-center">{item.TotalMarks}</td>
                                                                            <td className="text-center">{item.TotalObtainedMarks}</td>
                                                                            <td className="text-center"><b>{item.ResultType_Term}</b></td>
                                                                            <td className="w-150px">
                                                                                <input
                                                                                    type="text"
                                                                                    list="Remarkslist"
                                                                                    id={
                                                                                        "SemesterSubRemark_" +
                                                                                        item.ExamEnrollStdID
                                                                                    }
                                                                                    className="title-textbox"
                                                                                    defaultValue={item.SubRemark}
                                                                                /></td>
                                                                            <td className="w-150px">
                                                                                <input
                                                                                    type="text"
                                                                                    id={
                                                                                        "SemesterResultRemark_" +
                                                                                        item.ExamEnrollStdID
                                                                                    }
                                                                                    className="title-textbox"
                                                                                    defaultValue={item.ResultRemark}
                                                                                />
                                                                            </td>
                                                                            <td className="w-150px">
                                                                                <input
                                                                                    type="text"
                                                                                    id={
                                                                                        "SemesterAttendanceRemarks_" +
                                                                                        item.ExamEnrollStdID
                                                                                    }
                                                                                    data-semesterstudentid={item.StudentID}
                                                                                    className="title-textbox"
                                                                                    defaultValue={item.AttendanceRemarks}
                                                                                />
                                                                            </td>
                                                                        </tr>
                                                                    </>
                                                                )
                                                            ))}
                                                        </tbody>
                                                    </Table>

                                                    {
                                                        IsDataSaveing === false ?
                                                            <a
                                                                onClick={(e) =>
                                                                    fnSaveExamRemarks(SemesterStudentList.data, false, false, false, "SEMESTER EXAM")
                                                                }
                                                                className="btn btn-primary"
                                                            >
                                                                {commonService.LabelDisplayText("Save")}
                                                            </a>
                                                            :
                                                            <a
                                                                className="btn btn-primary"
                                                            >
                                                                <Spinner animation="border" size="sm" /> {commonService.LabelDisplayText("Saving")}
                                                            </a>
                                                    }
                                                </>
                                            ) : (
                                                <div className="error-message text-center"> This Exam is Already Publish Yo Cant Do It.</div>
                                            )}
                                        </>
                                    )}
                                </div>
                            </Tab>
                            <Tab eventKey="SemesterFinalRemark" title="Semester Final">
                                <div className="background-theme-color  notice-circular-event-searchbar attendence-header-section">
                                    <div className="row">
                                        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
                                            <div className="posting-section  align-items-center justify-content-between sticky-top attendence-search-section  first-attendence-section">
                                                <div className="row align-items-center m-0 selection-attendence-row">
                                                    <div className="col-12 p-0">
                                                        <div className="row">
                                                            <div className="col-4">
                                                                <Select
                                                                    className="attendence-select"
                                                                    placeholder={commonService.LabelDisplayText("SelectStandardDivision")}
                                                                    options={TeacherStdDiv}
                                                                    onChange={(e) => { GetSemesterFinalExamByStandardDivisionID(e) }}
                                                                    value={StandardDivisionSemesterFinal}
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                <div className="btn-group gap-2 multiple" role="group">
                                                                    {SemesterFinalExamName.map((exam) => (
                                                                        <button
                                                                            key={exam.value}
                                                                            type="button"
                                                                            className="btn btn-light ml-2"
                                                                        >
                                                                            {exam.label}
                                                                        </button>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                            <div className="col-2 pr-0">
                                                                <Button class="btn btn-primary align-items-center justify-content-center"
                                                                    onClick={() => BindSemesterFinalExamStudentList()}
                                                                >Get Data</Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {!SemesterFinalStudentList.IsData ? (
                                        <div className="row col-12">
                                            <_Skeleton
                                                type={_SkeletonType.Table}
                                                count={4}
                                                lineheight={30}
                                            />
                                        </div>
                                    ) : SemesterFinalStudentList.data.length === 0 ? (
                                        <div className="col-12 mt-5">
                                            <_NoDataFound fontsize={"150px"} />
                                        </div>
                                    ) : (
                                        <>
                                            {SemesterFinalStudentList.data.filter(x => x.IsPublish).length === 0 ? (
                                                <>
                                                    <div className="row">
                                                        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-6 mb-3">
                                                            <div className="posting-section  align-items-center justify-content-between  ">
                                                                <div className="d-flex align-items-center">
                                                                    <div className="header-date-area w-100 mr-3">
                                                                        <div className="d-flex align-items-center">
                                                                            <label className="from-date">
                                                                                {commonService.LabelDisplayText("DatepickerFrom")}
                                                                            </label>
                                                                            <DatePicker
                                                                                className="datepicker"
                                                                                selected={txtTermStartDate}
                                                                                dateFormat={data[0].DateFormat_Term}
                                                                                onChange={(date) => setTxtTermStartDate(date)}
                                                                                placeholderText={data[0].DateFormat_Term}
                                                                            />
                                                                        </div>
                                                                        <div className="d-flex align-items-center">
                                                                            <label className="from-date">
                                                                                {commonService.LabelDisplayText("DatepickerTo")}
                                                                            </label>
                                                                            <DatePicker
                                                                                className="datepicker"
                                                                                selected={txtTermEndDate}
                                                                                minDate={txtTermStartDate}
                                                                                dateFormat={data[0].DateFormat_Term}
                                                                                onChange={(date) => setTxtTermEndDate(date)}
                                                                                placeholderText={data[0].DateFormat_Term}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="right-icon-cal d-flex align-items-center">
                                                                        <div className="d-flex align-items-center">
                                                                            <Button class="btn btn-primary align-items-center justify-content-center"
                                                                                onClick={() => GetAttendance(StandardDivisionSemesterFinal, "SEMESTER FINAL EXAM")}
                                                                            >Attendance</Button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <Table responsive className="mark-entry-table">
                                                        <thead>
                                                            <tr>
                                                                <th className="w-75px">{commonService.LabelDisplayText("Seat")}</th>
                                                                <th className="w-350px">{commonService.LabelDisplayText("StudentName")}</th>
                                                                <th className="text-center w-100px">{commonService.LabelDisplayText("TotalMark")}</th>
                                                                <th className="text-center w-100px">{commonService.LabelDisplayText("NetObtainedMarks")}</th>
                                                                <th className="text-center w-100px">{commonService.LabelDisplayText("Result")}</th>
                                                                <th className="text-center">{commonService.LabelDisplayText("SubRemark")}</th>
                                                                <th className="text-center">{commonService.LabelDisplayText("ResultRemark")}</th>
                                                                <th className="text-center">{commonService.LabelDisplayText("AttendanceRemark")}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {SemesterFinalStudentList.data.map((item) => (
                                                                item.Result !== null && item.Result !== "" && (
                                                                    <>
                                                                        <tr key={item.StudentID} id={item.ResultID}>
                                                                            <td className="text-center">{item.SeatNo}</td>
                                                                            <td>{item.StudentFullName}</td>
                                                                            <td className="text-center">{item.TotalMarks}</td>
                                                                            <td className="text-center">{item.TotalObtainedMarks}</td>
                                                                            <td className="text-center"><b>{item.Result_Term}</b></td>
                                                                            <td className="w-150px">
                                                                                <input
                                                                                    type="text"
                                                                                    list="Remarkslist"
                                                                                    id={
                                                                                        "SemesterFinalSubRemark_" +
                                                                                        item.ResultID
                                                                                    }
                                                                                    className="title-textbox"
                                                                                    defaultValue={item.SubRemark}
                                                                                /></td>
                                                                            <td className="w-150px">
                                                                                <input
                                                                                    type="text"
                                                                                    id={
                                                                                        "SemesterFinalResultRemark_" +
                                                                                        item.ResultID
                                                                                    }
                                                                                    className="title-textbox"
                                                                                    defaultValue={item.ResultRemark}
                                                                                />
                                                                            </td>
                                                                            <td className="w-150px">
                                                                                <input
                                                                                    type="text"
                                                                                    id={
                                                                                        "SemesterFinalAttendanceRemarks_" +
                                                                                        item.ResultID
                                                                                    }
                                                                                    data-semesterfinalstudentid={item.StudentID}
                                                                                    className="title-textbox"
                                                                                    defaultValue={item.AttendanceRemarks}
                                                                                />
                                                                            </td>
                                                                        </tr>
                                                                    </>
                                                                )
                                                            ))}
                                                        </tbody>
                                                    </Table>

                                                    {
                                                        IsDataSaveing === false ?
                                                            <a
                                                                onClick={(e) =>
                                                                    fnSaveExamRemarks(SemesterFinalStudentList.data, false, true, false, "SEMESTER EXAM")
                                                                }
                                                                className="btn btn-primary"
                                                            >
                                                                {commonService.LabelDisplayText("Save")}
                                                            </a>
                                                            :
                                                            <a
                                                                className="btn btn-primary"
                                                            >
                                                                <Spinner animation="border" size="sm" /> {commonService.LabelDisplayText("Saving")}
                                                            </a>
                                                    }
                                                </>
                                            ) : (
                                                <div className="error-message text-center"> This Exam is Already Publish Yo Cant Do It.</div>
                                            )}
                                        </>
                                    )}
                                </div>
                            </Tab>
                            <Tab eventKey="ICSE/CBSEWiseRemark" title="CBSE Exam Wise">
                                <div className="background-theme-color  notice-circular-event-searchbar attendence-header-section">
                                    <div className="row">
                                        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
                                            <div className="posting-section  align-items-center justify-content-between sticky-top attendence-search-section  first-attendence-section">
                                                <div className="row align-items-center m-0 selection-attendence-row">
                                                    <div className="col-12 p-0">
                                                        <div className="row">
                                                            <div className="col-4">
                                                                <Select
                                                                    className="attendence-select"
                                                                    placeholder={commonService.LabelDisplayText("SelectStandardDivision")}
                                                                    options={TeacherStdDiv}
                                                                    onChange={(e) => { GetCBSEExamByStandardDivisionID(e) }}
                                                                    value={StandardDivisionCBSEExam}
                                                                />
                                                            </div>
                                                            <div className="col-4">
                                                                <Select
                                                                    className="attendence-select"
                                                                    placeholder={commonService.LabelDisplayText("SelectExam")}
                                                                    options={CBSEExamName}
                                                                    onChange={(e) => { CBSEExamChange(e) }}
                                                                    value={CBSEExamID}
                                                                />
                                                            </div>
                                                            <div className="col-2  pr-0">
                                                                <Button class="btn btn-primary align-items-center justify-content-center"
                                                                    onClick={() => BindCBSEExamStudentList()}
                                                                >Get Data</Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {!CBSEStudentList.IsData ? (
                                        <div className="row col-12">
                                            <_Skeleton
                                                type={_SkeletonType.Table}
                                                count={4}
                                                lineheight={30}
                                            />
                                        </div>
                                    ) : CBSEStudentList.data.length === 0 ? (
                                        <div className="col-12 mt-5">
                                            <_NoDataFound fontsize={"150px"} />
                                        </div>
                                    ) : (
                                        <>
                                            {CBSEStudentList.data.filter(x => x.IsPublish).length === 0 ? (
                                                <>
                                                    <div className="row">
                                                        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-6 mb-3">
                                                            <div className="posting-section  align-items-center justify-content-between ">
                                                                <div className="d-flex align-items-center">
                                                                    <div className="header-date-area w-100 mr-3">
                                                                        <div className="d-flex align-items-center">
                                                                            <label className="from-date">
                                                                                {commonService.LabelDisplayText("DatepickerFrom")}
                                                                            </label>
                                                                            <DatePicker
                                                                                className="datepicker"
                                                                                selected={txtTermStartDate}
                                                                                dateFormat={data[0].DateFormat_Term}
                                                                                onChange={(date) => setTxtTermStartDate(date)}
                                                                                placeholderText={data[0].DateFormat_Term}
                                                                            />
                                                                        </div>
                                                                        <div className="d-flex align-items-center">
                                                                            <label className="from-date">
                                                                                {commonService.LabelDisplayText("DatepickerTo")}
                                                                            </label>
                                                                            <DatePicker
                                                                                className="datepicker"
                                                                                selected={txtTermEndDate}
                                                                                minDate={txtTermStartDate}
                                                                                dateFormat={data[0].DateFormat_Term}
                                                                                onChange={(date) => setTxtTermEndDate(date)}
                                                                                placeholderText={data[0].DateFormat_Term}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="right-icon-cal d-flex align-items-center">
                                                                        <div className="d-flex align-items-center">
                                                                            <Button class="btn btn-primary align-items-center justify-content-center"
                                                                                onClick={() => GetAttendance(StandardDivisionCBSEExam, "CBSE EXAM")}
                                                                            >Attendance</Button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <Table responsive className="mark-entry-table">
                                                        <thead>
                                                            <tr>
                                                                <th className="w-75px">{commonService.LabelDisplayText("Seat")}</th>
                                                                <th className="w-350px">{commonService.LabelDisplayText("StudentName")}</th>
                                                                <th className="text-center w-100px">{commonService.LabelDisplayText("TotalMark")}</th>
                                                                <th className="text-center w-100px">{commonService.LabelDisplayText("NetObtainedMarks")}</th>
                                                                <th className="text-center w-100px">{commonService.LabelDisplayText("Result")}</th>
                                                                <th className="text-center">{commonService.LabelDisplayText("SubRemark")}</th>
                                                                <th className="text-center">{commonService.LabelDisplayText("ResultRemark")}</th>
                                                                <th className="text-center">{commonService.LabelDisplayText("AttendanceRemark")}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {CBSEStudentList.data.map((item) => (
                                                                item.Result !== null && item.Result !== "" && (
                                                                    <>
                                                                        <tr key={item.StudentID} id={item.ExamEnrollStdID}>
                                                                            <td className="text-center">{item.SeatNo}</td>
                                                                            <td>{item.StudentFullName}</td>
                                                                            <td className="text-center">{item.TotalMarks}</td>
                                                                            <td className="text-center">{item.TotalObtainedMarks}</td>
                                                                            <td className="text-center"><b>{item.ResultType_Term}</b></td>
                                                                            <td className="w-150px">
                                                                                <input
                                                                                    type="text"
                                                                                    list="Remarkslist"
                                                                                    id={
                                                                                        "CBSESubRemark_" +
                                                                                        item.ExamEnrollStdID
                                                                                    }
                                                                                    className="title-textbox"
                                                                                    defaultValue={item.SubRemark}
                                                                                /></td>
                                                                            <td className="w-150px">
                                                                                <input
                                                                                    type="text"
                                                                                    id={
                                                                                        "CBSEResultRemark_" +
                                                                                        item.ExamEnrollStdID
                                                                                    }
                                                                                    className="title-textbox"
                                                                                    defaultValue={item.ResultRemark}
                                                                                />
                                                                            </td>
                                                                            <td className="w-150px">
                                                                                <input
                                                                                    type="text"
                                                                                    id={
                                                                                        "CBSEAttendanceRemarks_" +
                                                                                        item.ExamEnrollStdID
                                                                                    }
                                                                                    data-cbsestudentid={item.StudentID}
                                                                                    className="title-textbox"
                                                                                    defaultValue={item.AttendanceRemarks}
                                                                                />
                                                                            </td>
                                                                        </tr>
                                                                    </>
                                                                )
                                                            ))}
                                                        </tbody>
                                                    </Table>
                                                    {
                                                        IsDataSaveing === false ?
                                                            <a
                                                                onClick={(e) =>
                                                                    fnSaveExamRemarks(CBSEStudentList.data, false, false, false, "CBSE EXAM")
                                                                }
                                                                className="btn btn-primary"
                                                            >
                                                                {commonService.LabelDisplayText("Save")}
                                                            </a>
                                                            :
                                                            <a
                                                                className="btn btn-primary"
                                                            >
                                                                <Spinner animation="border" size="sm" /> {commonService.LabelDisplayText("Saving")}
                                                            </a>
                                                    }
                                                </>
                                            ) : (
                                                <div className="error-message text-center"> This Exam is Already Publish Yo Cant Do It.</div>
                                            )}
                                        </>
                                    )}
                                </div>
                            </Tab>
                            <Tab eventKey="ICSE/CBSEFinalRemark" title="CBSE Final">
                                <div className="background-theme-color  notice-circular-event-searchbar attendence-header-section">
                                    <div className="row">
                                        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
                                            <div className="posting-section  align-items-center justify-content-between sticky-top attendence-search-section  first-attendence-section">
                                                <div className="row align-items-center m-0 selection-attendence-row">
                                                    <div className="col-12 p-0">
                                                        <div className="row">
                                                            <div className="col-4">
                                                                <Select
                                                                    className="attendence-select"
                                                                    placeholder={commonService.LabelDisplayText("SelectStandardDivision")}
                                                                    options={TeacherStdDiv}
                                                                    onChange={(e) => { GetCBSEFinalExamByStandardDivisionID(e) }}
                                                                    value={StandardDivisionCBSEFinal}
                                                                />
                                                            </div>
                                                            <div className="col-4">
                                                                <Select
                                                                    className="attendence-select"
                                                                    placeholder={commonService.LabelDisplayText("SelectExam")}
                                                                    options={CBSEFinalExamName}
                                                                    onChange={(e) => { CBSEFinalExamChange(e) }}
                                                                    value={CBSEFinalExamID}
                                                                />
                                                            </div>
                                                            <div className="col-2  pr-0">
                                                                <Button class="btn btn-primary align-items-center justify-content-center"
                                                                    onClick={() => BindCBSEFinalExamStudentList()}
                                                                >Get Data</Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {!CBSEFinalStudentList.IsData ? (
                                        <div className="row col-12">
                                            <_Skeleton
                                                type={_SkeletonType.Table}
                                                count={4}
                                                lineheight={30}
                                            />
                                        </div>
                                    ) : CBSEFinalStudentList.data.length === 0 ? (
                                        <div className="col-12 mt-5">
                                            <_NoDataFound fontsize={"150px"} />
                                        </div>
                                    ) : (
                                        <>
                                            {CBSEFinalStudentList.data.filter(x => x.IsPublish).length === 0 ? (
                                                <>
                                                    <div className="row">
                                                        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-6 mb-3">
                                                            <div className="posting-section  align-items-center justify-content-between   ">
                                                                <div className="d-flex align-items-center">
                                                                    <div className="header-date-area w-100 mr-3">
                                                                        <div className="d-flex align-items-center">
                                                                            <label className="from-date">
                                                                                {commonService.LabelDisplayText("DatepickerFrom")}
                                                                            </label>
                                                                            <DatePicker
                                                                                className="datepicker"
                                                                                selected={txtTermStartDate}
                                                                                dateFormat={data[0].DateFormat_Term}
                                                                                onChange={(date) => setTxtTermStartDate(date)}
                                                                                placeholderText={data[0].DateFormat_Term}
                                                                            />
                                                                        </div>
                                                                        <div className="d-flex align-items-center">
                                                                            <label className="from-date">
                                                                                {commonService.LabelDisplayText("DatepickerTo")}
                                                                            </label>
                                                                            <DatePicker
                                                                                className="datepicker"
                                                                                selected={txtTermEndDate}
                                                                                minDate={txtTermStartDate}
                                                                                dateFormat={data[0].DateFormat_Term}
                                                                                onChange={(date) => setTxtTermEndDate(date)}
                                                                                placeholderText={data[0].DateFormat_Term}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="right-icon-cal d-flex align-items-center">
                                                                        <div className="d-flex align-items-center">
                                                                            <Button class="btn btn-primary align-items-center justify-content-center"
                                                                                onClick={() => GetAttendance(StandardDivisionCBSEFinal, "CBSE FINAL EXAM")}
                                                                            >Attendance</Button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <Table responsive className="mark-entry-table">
                                                        <thead>
                                                            <tr>
                                                                <th className="w-75px">{commonService.LabelDisplayText("Seat")}</th>
                                                                <th className="w-350px">{commonService.LabelDisplayText("StudentName")}</th>
                                                                <th className="text-center w-100px">{commonService.LabelDisplayText("TotalMark")}</th>
                                                                <th className="text-center w-100px">{commonService.LabelDisplayText("NetObtainedMarks")}</th>
                                                                <th className="text-center w-100px">{commonService.LabelDisplayText("Result")}</th>
                                                                <th className="text-center">{commonService.LabelDisplayText("SubRemark")}</th>
                                                                <th className="text-center">{commonService.LabelDisplayText("ResultRemark")}</th>
                                                                <th className="text-center">{commonService.LabelDisplayText("AttendanceRemark")}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {CBSEFinalStudentList.data.map((item) => (
                                                                item.Result !== null && item.Result !== "" && (
                                                                    <>
                                                                        <tr key={item.StudentID} id={item.ResultID}>
                                                                            <td className="text-center">{item.SeatNo}</td>
                                                                            <td>{item.StudentFullName}</td>
                                                                            <td className="text-center">{item.TotalMarks}</td>
                                                                            <td className="text-center">{item.Obtained}</td>
                                                                            <td className="text-center"><b>{item.Result_Term}</b></td>
                                                                            <td className="w-150px">
                                                                                <input
                                                                                    type="text"
                                                                                    list="Remarkslist"
                                                                                    id={
                                                                                        "CBSEFinalSubRemark_" +
                                                                                        item.ResultID
                                                                                    }
                                                                                    className="title-textbox"
                                                                                    defaultValue={item.SubRemark}
                                                                                /></td>
                                                                            <td className="w-150px">
                                                                                <input
                                                                                    type="text"
                                                                                    id={
                                                                                        "CBSEFinalResultRemark_" +
                                                                                        item.ResultID
                                                                                    }
                                                                                    className="title-textbox"
                                                                                    defaultValue={item.ResultRemark}
                                                                                />
                                                                            </td>
                                                                            <td className="w-150px">
                                                                                <input
                                                                                    type="text"
                                                                                    id={
                                                                                        "CBSEFinalAttendanceRemarks_" +
                                                                                        item.ResultID
                                                                                    }
                                                                                    data-cbsefinalstudentid={item.StudentID}
                                                                                    className="title-textbox"
                                                                                    defaultValue={item.AttendanceRemarks}
                                                                                />
                                                                            </td>
                                                                        </tr>
                                                                    </>
                                                                )
                                                            ))}
                                                        </tbody>
                                                    </Table>

                                                    {
                                                        IsDataSaveing === false ?
                                                            <a
                                                                onClick={(e) =>
                                                                    fnSaveExamRemarks(CBSEFinalStudentList.data, false, false, true, "CBSE EXAM")
                                                                }
                                                                className="btn btn-primary"
                                                            >
                                                                {commonService.LabelDisplayText("Save")}
                                                            </a>
                                                            :
                                                            <a
                                                                className="btn btn-primary"
                                                            >
                                                                <Spinner animation="border" size="sm" /> {commonService.LabelDisplayText("Saving")}
                                                            </a>
                                                    }
                                                </>
                                            ) : (
                                                <div className="error-message text-center"> This Exam is Already Publish Yo Cant Do It.</div>
                                            )}
                                        </>
                                    )}
                                </div>
                            </Tab>
                        </Tabs>
                        <datalist id="Remarkslist">
                            {ResultProcessRemarks.map((student) => (
                                <option key={student.value} value={student.label} />
                            ))}
                        </datalist>
                    </Tab>
                }

                {data[0].MemberType.toLowerCase() === "student" &&
                    <Tab eventKey="ExamResult" title={commonService.LabelDisplayText("ExamResult")}>
                        <Tabs
                            defaultActiveKey="Weekly"
                            id="uncontrolled-tab-example"
                            className="mb-3 exam-result-tabs chapter-detail-tabs"
                        >
                            <Tab eventKey="Weekly" title={commonService.LabelDisplayText("WeeklyResult")}>
                                <div className="row">
                                    {WeeklyResult.data.map((item, index) => (
                                        <div
                                            key={index}
                                            className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-4 mb-3"
                                        >
                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="d-flex">
                                                        <div className="w-100">
                                                            <div className="col-12 d-flex align-items-center justify-content-between p-0 mb-2 exam-result-header">
                                                                <h2 className="card-body-header exam-result-header m-0">
                                                                    <span className="bus-number-plate">
                                                                        {item.SubjectName}
                                                                    </span>
                                                                    <span className="exam-result-year">
                                                                        {item.StandardName}-{item.DivisionName} (
                                                                        {item.BatchName})
                                                                    </span>
                                                                </h2>
                                                            </div>
                                                            <div className="bus-name-number">
                                                                <p className="bus-number-plate exam-result-date  mb-1">
                                                                    {commonService.getDateInFormat(item.DateOfExam)}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="weekly-report-chart">
                                                            <Doughnut
                                                                className="weekly-report-chart"
                                                                data={{
                                                                    datasets: [
                                                                        {
                                                                            data: [item.TotalMarks - item.ObtainedMarks, item.ObtainedMarks],
                                                                            backgroundColor: ["#10AB4A", "#FFAE48"],
                                                                            borderWidth: [3, 8],
                                                                            borderColor: ["#10AB4A", "#FFAE48"],
                                                                        },
                                                                    ],
                                                                }}
                                                                options={{
                                                                    cutout: 40,
                                                                }}
                                                            />
                                                            <div className="weekly-chart-numbers">
                                                                <span className="weekly-chart-highest">
                                                                    {item.TotalMarks}
                                                                </span>
                                                                /
                                                                <span className="weekly-chart-lowest">
                                                                    {item.ObtainedMarks}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="marks-indicators d-flex align-items-center justify-content-around mt-2">
                                                        <div className="d-flex text-align-center align-items-center">
                                                            <span className="mb-1">{commonService.LabelDisplayText("Standard")}</span>
                                                            <div className="std-highest" title={commonService.LabelDisplayText("Standard") + " Highest"}>
                                                                <label className="mb-1">
                                                                    {item.ClassHighest}<br />
                                                                    <p style={{ fontSize: "8px" }} className="align-items-center">High</p>
                                                                </label>
                                                            </div>
                                                            <div className="std-Lowest">
                                                                <label className="mb-1" title={commonService.LabelDisplayText("Standard") + " Highest"}>
                                                                    {item.ClassLowest}<br />
                                                                    <p style={{ fontSize: "8px" }} className="align-items-center">Low</p>
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="d-flex text-align-center align-items-center">
                                                            <span className="mb-1">{commonService.LabelDisplayText("Section")}</span>
                                                            <div className="sec-highest" title={commonService.LabelDisplayText("Section") + " Highest"}>
                                                                <label className="mb-1">
                                                                    {item.DivisionHighest}<br />
                                                                    <p style={{ fontSize: "8px" }} className="text-items-center">High</p>
                                                                </label>
                                                            </div>
                                                            <div className="sec-lowest" title={commonService.LabelDisplayText("Section") + " Lowest"}>
                                                                <label className="mb-1">
                                                                    {item.DivsionLowest}<br />
                                                                    <p style={{ fontSize: "8px" }} className="text-items-center">Low</p>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </Tab>
                            <Tab eventKey="Terms" title={commonService.LabelDisplayText("TermsResult")}>
                                <div className="row">
                                    {TermsResult.data.map((item, index) => (
                                        <div
                                            key={index}
                                            className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-4 mb-3"
                                        >
                                            <a
                                                onClick={(e) =>
                                                    viewFilePopupService.viewFilePopup({
                                                        data: [
                                                            {
                                                                Name: item.ExamName,
                                                                FilePath:
                                                                    AppConfigData.ERPFileBasePath +
                                                                    item.ClientID +
                                                                    "/" +
                                                                    item.InstituteID +
                                                                    "/MarkSheets/" +
                                                                    item.ID +
                                                                    ".pdf",
                                                                OrderNo: 1,
                                                                FileType: "PDF",
                                                            },
                                                        ],
                                                    })
                                                }
                                            >
                                                <div className="card">
                                                    <div className="card-body">
                                                        <div className="col-12 d-flex align-items-center justify-content-between p-0 exam-result-header">
                                                            <h2 className="card-body-header exam-result-header m-0">
                                                                {item.ExamName} ({commonService.LabelDisplayText("STDDIV")} : {item.Standard} -{" "}
                                                                {item.Division} , {commonService.LabelDisplayText("Year")} : {item.Year})
                                                            </h2>

                                                            <i className="fa-regular fa-file-lines"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    ))}
                                </div>
                            </Tab>
                            <Tab eventKey="Semester" title={commonService.LabelDisplayText("SemResult")}>
                                {SemResult.data.map((item, index) => (
                                    <div
                                        key={index}
                                        className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-3"
                                    >
                                        <a
                                            onClick={(e) =>
                                                viewFilePopupService.viewFilePopup({
                                                    data: [
                                                        {
                                                            Name: item.ExamName,
                                                            FilePath:
                                                                AppConfigData.ERPFileBasePath +
                                                                item.ClientID +
                                                                "/" +
                                                                item.InstituteID +
                                                                "/MarkSheets/" +
                                                                item.ID +
                                                                ".pdf",
                                                            OrderNo: 1,
                                                            FileType: "PDF",
                                                        },
                                                    ],
                                                })
                                            }
                                        >
                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="col-12 d-flex align-items-center justify-content-between p-0 exam-result-header">
                                                        <h2 className="card-body-header exam-result-header m-0">
                                                            {item.ExamName} ({commonService.LabelDisplayText("STDDIV")} : {item.Standard} -{" "}
                                                            {item.Division} , {commonService.LabelDisplayText("Year")} : {item.Year})
                                                        </h2>
                                                        <i className="fa-regular fa-file-lines"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                ))}
                            </Tab>
                            <Tab eventKey="ICSE/CBSE" title={commonService.LabelDisplayText("CBSEResult")}>
                                {CbseResult.data.map((item, index) => (
                                    <div
                                        key={index}
                                        className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-3"
                                    >
                                        <a
                                            onClick={(e) =>
                                                viewFilePopupService.viewFilePopup({
                                                    data: [
                                                        {
                                                            Name: item.ExamName,
                                                            FilePath:
                                                                AppConfigData.ERPFileBasePath +
                                                                item.ClientID +
                                                                "/" +
                                                                item.InstituteID +
                                                                "/MarkSheets/" +
                                                                item.ID +
                                                                ".pdf",
                                                            OrderNo: 1,
                                                            FileType: "PDF",
                                                        },
                                                    ],
                                                })
                                            }
                                        >
                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="col-12 d-flex align-items-center justify-content-between p-0 exam-result-header">
                                                        <h2 className="card-body-header exam-result-header m-0">
                                                            {item.ExamName} ({commonService.LabelDisplayText("STDDIV")} : {item.Standard} -{" "}
                                                            {item.Division} , {commonService.LabelDisplayText("Year")} : {item.Year})
                                                        </h2>
                                                        <i className="fa-regular fa-file-lines"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                ))}
                            </Tab>
                        </Tabs>
                    </Tab>
                }
            </Tabs>
        </>
    );
}

export default Exam;
